<!--
frontend-author:bhavya, vaishnavi,
backend-author: bhavya,
page-name : invoice create.vue,
page-description : invoice create for invoice,
started at : 16-Apr-2019,
edited at :18-Jun-2019.
-->
<!-- Html code for invocie create-->
<template>
  <div class="invoice-create-page" style="margin-top:-10px;">
    <!--  heading block -->
    <GlobalHeader :title="'Generate Invoice for '+list.amc_no" @redirectPage="redirectPage"></GlobalHeader>
    <b-row class="mt-2 px-pad">
      <b-col xl="12" lg="12" md="12" xs="12" sm="12" class="px-0">
        <div class="container-fluid">
          <b-alert class="alert-transparent alert-danger" :show="duplicatecode">
            <p class="fw-semi-bold">{{ message }}</p>
          </b-alert>
          <b-alert class="alert-transparent alert-danger" :show="error_show && this.errors.any()">
            <button type="button" @click="error_show=!error_show" class="close">
              <span aria-hidden="true">&times;</span>
            </button>

            <div v-for="item in errors.items" :key="item.id" v-if="item.scope=='amc-invoice-form'">
              <p class="fw-semi-bold">{{ item.msg }}</p>
            </div>
          </b-alert>
        </div>
      </b-col>
    </b-row>

    <b-form
      @submit.prevent="onSubmit('amc-invoice-form')"
      id="invoice_form"
      data-vv-scope="amc-invoice-form"
      class="mt-1"
      style="margin-left:3px;margin-right:3px;"
    >
      <!-- <div style="background:#f9fbfd !important"> -->
      <div class="sales-bg pt-30p pb-4 mb-2 border-bottom-dot" style="background:#f7f7f7">
        <!--  customer input block -->
        <b-row>
          <b-col xl="10" lg="9" md="9" sm="12" xs="12" @click="removecustomer" class="pr-1">
            <b-form-group>
              <span v-if="org_details.org_state == ''">Note :Please update your organizaiton state</span>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control input_customer_search"
                  :value="field.cus_name"
                  disabled
                />
                <template v-if="field.cus_id != ''">
                  <span
                    class="ml-2 mt-2 mr-1 cursor_pointer"
                    v-b-tooltip
                    title="View Customer Details"
                    @click="toggleCustomerDetails()"
                    v-if="RoutePermission(false,'','invoice','customer','index')"
                  >
                    <i class="la la-external-link la-lg"></i>
                  </span>

                  <span class="pl-1 mt-2 cursor_pointer">
                    <b-badge variant="success" size="xs">{{field.currency_code}}</b-badge>
                  </span>
                </template>
              </div>
            </b-form-group>
          </b-col>
          <b-col xl="2" lg="3" md="3" sm="3" xs="3" class="text-right pl-0">
            <h3
              style="margin-bottom:0px"
              class="text-truncate"
              v-b-tooltip
              :title="parseFloat(total_header).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 })"
            >
              {{getDetails(
              $AppDetails.currency_details,
              (field.cus_currency || $AppDetails.organization.org_currency),
              "currency_symbol"
              )+" "+parseFloat(total_header).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}
            </h3>
          </b-col>
        </b-row>
        <b-row class="mt-2 mb-3">
          <b-col>
            <template
              v-if="field.cus_id != ''&&RoutePermission(false,'','invoice','customer','update')"
            >
              <p class="text-muted fw-semi-bold">
                Address
                <span
                  v-if="(cusaddress.is_billing!=0||cusaddress.is_shipping!=0)"
                  class="ml-1 pr-1 mt-2 cursor_pointer theme-text-color"
                  v-b-tooltip
                  title="Edit Customer Address"
                  @click="toggleCustomerAddressDetails()"
                >Edit</span>
                <span style="height:8px;border-left:1px solid #cecece"></span>

                <span
                  class="ml-1 mt-2 cursor_pointer theme-text-color"
                  title="Add Customer Address"
                  @click="addresspage='create',toggleCustomerAdditionalDetails()"
                >Add</span>
              </p>
            </template>
          </b-col>
        </b-row>
        <b-row style="max-width:1000px;" class="mt-2">
          <b-col cols="12" lg="5" md="6" sm="8" v-if="org_details.gst_type == 1">
            <b-form-group
              label-class="required"
              label="Place of supply"
              label-for="state-select"
              class="mb-3"
            >
              <v-select
                :clearable="false"
                :disabled="field.place_of_supply=='97'||page == 'update' && parseInt(list.available_credits) > 0 ? true : false"
                id="state-select"
                v-model.trim="field.place_of_supply"
                placeholder="Choose place of supply"
                size="sm"
                index="state_id"
                label="state_name"
                @input="changetax($event)"
                :options="field.buyer_gst_type==6?$AppDetails.state_list:$AppDetails.state_list.filter(x=>x.state_id!='97')"
                v-validate="'required'"
                name="place_supply"
                data-vv-name="place of supply"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" lg="5" md="6" sm="8" v-if="field.is_export == 2">
            <b-form-group
              :label="'Country of supply'"
              label-class="required"
              label-for="state-select"
              class="mb-3"
            >
              <v-select
                :clearable="false"
                :disabled="page == 'update' && parseInt(list.available_credits) > 0 ? true : false"
                id="state-select"
                v-validate="'required'"
                v-model.trim="field.country_of_supply"
                placeholder="Choose country of supply"
                size="sm"
                index="country_id"
                label="country_name"
                :options="$AppDetails.country_list"
                name="country_of_supply"
                data-vv-name="country of supply"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" lg="5" md="6" sm="8">
            <b-form-group
              label="Sales Location"
              label-for="sales_location"
              v-if="parseInt(org_details.org_warehouse_count) > 1"
              class="mb-3"
            >
              <v-select
                :clearable="false"
                size="sm"
                :options="location_detail"
                label="label"
                id="warehouse_id-select"
                index="value"
                @input="changelocationallitems(field.warehouse_id)"
                v-model.trim="field.warehouse_id"
                class="form-vselect"
              >
                <template slot="option" slot-scope="option">
                  <div class="d-flex w-100 v-select-option" :title="option.label">
                    <div class="text-truncate" style="width:100%">{{ option.label }}</div>
                  </div>
                </template>
              </v-select>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
      <b-row style="max-width:1000px;" class="mt-4">
        <b-col cols="12" lg="5" md="6" sm="8">
          <b-form-group
            :label="'Invoice'"
            label-class="required"
            label-for="invoice-code"
            class="mb-3"
            v-if="inv_settings_details.inv_code_field"
          >
            <b-input-group class="vselect-custom-add">
              <template slot="append">
                <b-input-group-text
                  class="vselect-custom-add-icon"
                  v-b-tooltip
                  title="Customize auto generate code"
                  style="margin-left:2px"
                  v-on:click="$root.$emit('bv::show::modal', 'addautogeneratecode')"
                >
                  <i class="la la-cog"></i>
                </b-input-group-text>
              </template>

              <template slot="prepend">
                <b-form-input
                  style="border-top-right-radius:0 !important;border-bottom-right-radius:0 !important"
                  type="text"
                  size="sm"
                  name="Invoice"
                  data-vv-name="invoice"
                  v-model.trim="field.inv_no"
                  v-validate="'required|max:16'"
                />
              </template>
            </b-input-group>
          </b-form-group>
          <b-form-group label="Reference No." label-for="ref_no" class="mb-3">
            <b-form-input
              type="text"
              size="sm"
              name="ref_no"
              v-model.trim="field.ref_no"
              data-vv-name="reference no"
              v-validate="'max:30'"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="5" md="6" sm="8">
          <b-form-group
            :label="'Invoice Date'"
            label-class="required"
            label-for="invoice_date"
            class="mb-3"
          >
            <DatePicker
              :disabled="inv_settings_details.edit_inv_created_date"
              :format="$AppDetails.organization.date_format"
              name="creatdate"
              data-vv-name="invoice date"
              :not-after="field.inv_due_date"
              v-validate="'required'"
              v-model.trim="field.sales_date"
              input-name="creatdate"
              ref="creatdate"
              lang="en"
              input-class="form-control"
              @change="selectDate"
              style="width:100% !important;"
              id="start_date"
              placeholder=" "
            >
              <i class="fa fa-calendar text-dark" slot="calendar-icon" />
            </DatePicker>
          </b-form-group>
          <b-form-group :label="'Due Date'" label-for="duedate" class="mb-3">
            <DatePicker
              placeholder=" "
              :format="$AppDetails.organization.date_format"
              v-model.trim="field.inv_due_date"
              input-name="duedate"
              lang="en"
              input-class="form-control"
              @change="selectDueDate"
              style="width:100% !important;"
              name="validduedate"
              id="end_date"
              data-vv-name="due date"
              :not-before="field.sales_date"
              v-validate="'date_format:yyyy-MM-dd'"
            >
              <i class="fa fa-calendar text-dark" slot="calendar-icon" />
            </DatePicker>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row style="max-width:1000px;" class="mt-4 mb-2 pt-2">
        <b-col cols="12" lg="5" md="6" sm="8">
          <b-form-group label="Sales Person" label-for="tags-select" class="mb-3">
            <b-input-group class="vselect-custom-add">
              <template slot="append">
                <b-input-group-text
                  v-b-tooltip
                  title="Add Sales Person"
                  class="vselect-custom-add-icon"
                  v-on:click="callsalespersonmodal({sales_person_id:'',sales_person_name:'',sales_person_mail:'',sales_person_ph_no:''})"
                >&#43;</b-input-group-text>
              </template>
              <template slot="prepend">
                <v-select
                  :clearable="field.sales_person_id!=''&&field.sales_person_id!=null"
                  @input="$event==null?field.sales_person_id='':''"
                  size="sm"
                  :options="sales_person_list"
                  label="label"
                  index="value"
                  id="salesperson-select"
                  v-model.trim="field.sales_person_id"
                  placeholder="Choose sales person"
                  name="sale_per"
                  class="form-vselect"
                >
                  <template slot="option" slot-scope="option">
                    <div class="d-flex w-100 v-select-option" :title="option.label">
                      <div class="text-truncate" style="width:292px">{{ option.label }}</div>
                      <span class="select-hover-block">
                        <span
                          class="la la-edit la-lg float-right"
                          v-on:click.stop="callsalespersonmodal({sales_person_id:option.value,sales_person_name:option.label,sales_person_mail:option.sales_person_mail,sales_person_ph_no:option.sales_person_ph_no})"
                        ></span>
                        <span
                          class="glyphicon glyphicon-trash float-right pl-2"
                          v-on:click.stop="salespersondelete=true,calldeletemodal(option.value)"
                        ></span>
                      </span>
                    </div>
                  </template>
                </v-select>
              </template>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col cols="12" lg="5" md="6" sm="8" v-if="inv_settings_details.pjt_field">
          <b-form-group label="Project" label-for="Project" class="mb-3">
            <b-input-group class="vselect-custom-add">
              <template slot="append">
                <b-input-group-text
                  v-b-tooltip
                  title="Add Project"
                  class="vselect-custom-add-icon"
                  v-on:click="callprojectmodal({pjt_id:'',pjt_name:''})"
                >&#43;</b-input-group-text>
              </template>
              <template slot="prepend">
                <v-select
                  :clearable="field.pjt_id!=''&&field.pjt_id!=null"
                  @input="$event==null?field.pjt_id='':''"
                  size="sm"
                  :options="pjt_list"
                  label="label"
                  index="value"
                  id="project-select"
                  v-model.trim="field.pjt_id"
                  class="form-vselect"
                  name="pmt_id"
                  data-vv-name="project"
                >
                  <template slot="option" slot-scope="option">
                    <div class="d-flex w-100 v-select-option" :title="option.label">
                      <div class="text-truncate" style="width:292px">{{ option.label }}</div>
                      <span class="select-hover-block">
                        <span
                          class="la la-edit la-lg float-right"
                          v-on:click.stop="callprojectmodal({pjt_id:option.value,pjt_name:option.label})"
                        ></span>
                        <span
                          class="glyphicon glyphicon-trash float-right pl-2"
                          v-on:click.stop="salesprojectdelete=true,calldeletemodal(option.value)"
                        ></span>
                      </span>
                    </div>
                  </template>
                </v-select>

                <span class="text-danger" v-if="errors.has('pmt_id')">Please enter project name</span>
              </template>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="5" md="6" sm="8">
          <b-form-group label="Order No." label-for="order_no" class="mb-3">
            <b-form-input
              type="text"
              size="sm"
              name="ref_no"
              v-model.trim="field.order_no"
              data-vv-name="reference number"
              v-validate="'max:20'"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row style="max-width:1000px;">
        <b-col cols="12" lg="10" md="12" sm="12" class="mt-2">
          <b-form-group label=" Invoice Tags" class="mb-3" label-for="tags-select">
            <b-input-group class="vselect-custom-add">
              <template slot="append">
                <b-input-group-text
                  class="vselect-custom-add-icon"
                  v-b-tooltip
                  title="Add Tags"
                  v-on:click="invoicetagmodal = true,updatetag=false,calltagmodal({tag_id:'',tag_name:''})"
                >&#43;</b-input-group-text>
              </template>
              <template slot="prepend">
                <v-select
                  :clearable="false"
                  multiple
                  size="sm"
                  :options="tag_list"
                  label="label"
                  index="value"
                  id="tags-select"
                  v-model.trim="field.inv_tags"
                >
                  <template slot="option" slot-scope="option">
                    <div class="d-flex w-100 v-select-option" :title="option.label">
                      <div class="text-truncate" style="width:calc(100% - 40px)">{{ option.label }}</div>
                      <span class="select-hover-block">
                        <span
                          class="la la-edit la-lg float-right"
                          v-on:click.prevent="invoicetagmodal = true,updatetag=true,calltagmodal({tag_id:option.value,tag_name:option.label})"
                        ></span>
                        <span
                          class="glyphicon glyphicon-trash float-right pl-2"
                          v-on:click.stop="invoicetagdelete = true,calldeletemodal(option.value)"
                        ></span>
                      </span>
                    </div>
                  </template>
                </v-select>
              </template>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>

      <template v-if="field.is_export == 2">
        <b-row style="max-width:1000px" class="mt-4 mb-2 pt-2">
          <b-col>
            <h6
              class="text-primary pr-2 py-2 fw-semi-bold cursor_pointer h6-lg"
              v-b-toggle.export-details
            >
              Export details
              <i class="fa fa-angle-down fw-semi-bold ml-1"></i>
            </h6>
          </b-col>
        </b-row>
        <b-collapse id="export-details" visible>
          <b-row style="max-width:1000px;">
            <b-col cols="12" lg="5" md="6" sm="8">
              <b-form-group
                :label="'Export Type'"
                label-class="required"
                label-for="export-type"
                class="mb-3"
              >
                <v-select
                  :clearable="false"
                  size="sm"
                  :options="export_type_list"
                  label="label"
                  index="value"
                  id="export-type-select"
                  v-model.trim="field.export_type"
                  name="Export type"
                  v-validate="'required'"
                  data-vv-name="export type"
                >
                  <template slot="option" slot-scope="option">{{ option.label }}</template>
                </v-select>
              </b-form-group>
              <b-form-group label="Shipping Bill No." label-for="bill-no" class="mb-3">
                <b-form-input
                  id="bill-no"
                  v-model.trim="field.shipping_bill_number"
                  name="Shipping Bill No"
                  data-vv-name="shipping bill no"
                  v-validate="'max:15'"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="5" md="6" sm="8">
              <b-form-group label="Shipping Bill Date" label-for="bill-date" class="mb-3">
                <DatePicker
                  placeholder=" "
                  :format="$AppDetails.organization.date_format"
                  v-model.trim="field.shipping_bill_date"
                  input-name="Shipping Bill date"
                  lang="en"
                  input-class="form-control"
                  @change="selectShippingDate"
                  style="width:100% !important;"
                  id="Shipping Bill date"
                >
                  <i class="fa fa-calendar text-dark" slot="calendar-icon" />
                </DatePicker>
              </b-form-group>
              <b-form-group label="Shipping Port Code" label-for="port-code" class="mb-3">
                <b-form-input
                  id="port-code"
                  type="text"
                  size="sm"
                  name="Shipping Port code"
                  v-model.trim="field.shipping_port_code"
                  data-vv-name="shipping port code"
                  v-validate="'max:15'"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </b-collapse>
      </template>
      <b-row
        style="max-width:1000px"
        class="mt-4 mb-2 pt-2"
        v-if="inv_settings_details.custom_field.length > 0"
      >
        <b-col>
          <h6
            class="text-primary pr-2 py-2 fw-semi-bold cursor_pointer h6-lg"
            v-b-toggle.collapse-1
          >
            Custom fields
            <i class="fa fa-angle-down fw-semi-bold ml-1"></i>
          </h6>
        </b-col>
      </b-row>
      <b-collapse id="collapse-1" visible>
        <b-row style="max-width:1000px;">
          <b-col
            cols="12"
            lg="5"
            md="6"
            sm="8"
            :key="index"
            v-for="(custom_field,index) in inv_settings_details.custom_field"
            v-if="custom_field.status == 1 && custom_field.permissions == 'write'"
          >
            <CustomPreview
              v-on:assigncustomvalue="assigncustomvalue($event)"
              :custom="custom_field"
              :disabled="false"
              :modelname="field[custom_field.field_name]"
            />
            <input
              type="hidden"
              :name="custom_field.label_name"
              :data-vv-name="custom_field.label_name"
              v-validate="custom_field.validation"
              v-model="field[custom_field.field_name]"
            />
          </b-col>
        </b-row>
      </b-collapse>
      <b-row style="max-width:1000px;" class="my-3"  v-if="field.tax_exempt == 0 && (field.buyer_gst_type == 1 || field.buyer_gst_type == 2||field.buyer_gst_type == 8)">
        <b-col xl="12" lg="12" md="12" sm="12" xs="12" >
          <b-form-group>
            <b-form-checkbox
              id="is_tax_reverse_charge"
              v-model.trim="field.is_tax_reverse_charge"
              name="is_tax_reverse_charge"
              value="1"
              unchecked-value="0"
              @change="changedReverseCharge"
            >Tax payable on reverse charge basis</b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>

      <div class="mt-5" style="max-width:1345px;display:flow-root">
        <b-form-select
          v-model.trim="field.tax_type_id"
          class="bord-bottom-input tax_type float-left form-control"
          style="padding-left:0px !important;"
          v-if="general_settings_details.preferences.tax_type_id == 3 && org_details.gst_type == 1&&type=='invoice'"
        >
          <option value="1">Inclusive Tax</option>
          <option value="2">Exclusive Tax</option>
        </b-form-select>
        <div class="row">
          <b-col cols="3">
            <v-select
              style="width:100%"
              label="label"
              index="value"
              data-vv-name="price list"
              class="float-left bord-btm-vselect form-vselect"
              id="search-select"
              @change="alertpricelist()"
              v-if="price_list.length > 0 && enablepricelist.is_price_list_enabled == 1"
              v-model.trim="field.pricing_hdr_id"
              size="sm"
              placeholder="Price List"
              :options="pricelistgenerate"
            >
              <template slot="option" slot-scope="option">
                <div class="d-flex w-100 v-select-option" :title="option.label">
                  <div class="text-truncate" style="width:100%">{{ option.label }}</div>
                </div>
              </template>
            </v-select>
          </b-col>
          <b-col cols="9">
            <span v-if="field.is_export == 2" class="float-right display-flex fw-semi-bold mr-3">
              <span
                v-if=" currency_details.exchange_rate_date!=''||org_details.exchange_rate_status==0"
              >
                <small v-if="changed_currency==false" class="d-block">Exchange rate as on creation,</small>
                <small
                  v-else
                  class="d-block"
                >As of Date: {{currency_details.exchange_rate_date!=''?getDateFormat(currency_details.exchange_rate_date):getDateFormat(field.sales_date)}}</small>
                <span class="float-right" style="font-size:11px;">
                  1 {{field.currency_code}} = {{parseFloat(field.unit_currency_value)}} {{orgCurrency}}
                  <span>
                    <b-dropdown
                      class="exchange-dropdown"
                      right
                      toggle-class="p-0 text-decoration-none"
                      variant="link"
                      no-caret
                      size="xs"
                      ref="exchange_rate_dropdown"
                    >
                      <template slot="button-content">
                        <i
                          class="la la-edit la-lg theme-text-color pl-1"
                          style="top:-2px;position:relative"
                          @click="exchange_rate_details={ currency_exchange_rate: field.unit_currency_value , save_exchange_rate: 0, recalc: 0 }"
                        ></i>
                      </template>
                      <b-dropdown-header>Edit Exchange Rate</b-dropdown-header>
                      <b-dropdown-divider></b-dropdown-divider>
                      <b-dropdown-form class="p-3" style="width:250px;">
                        <b-row>
                          <b-col>
                            <b-form-group
                              :label="'Exchange Rate(in '+orgCurrency+')'"
                              label-class="required"
                              label-for="ex-rate"
                            >
                              <b-input
                                style="width:130px"
                                @blur="exchange_rate_details.currency_exchange_rate = exchange_rate_details.currency_exchange_rate==''||parseFloat(exchange_rate_details.currency_exchange_rate) <=  0||parseFloat(exchange_rate_details.currency_exchange_rate) >  100000000000000||isNaN(parseFloat(exchange_rate_details.currency_exchange_rate))? 1 : parseFloat(exchange_rate_details.currency_exchange_rate)"
                                v-model="exchange_rate_details.currency_exchange_rate"
                              ></b-input>
                            </b-form-group>
                            <b-checkbox
                              v-if="org_details.exchange_rate_status==1&&page=='create'"
                              unchecked-value="0"
                              value="1"
                              v-model="exchange_rate_details.save_exchange_rate"
                              class="mt-2"
                            >
                              <small>Set this rate as default for {{getDateFormat(field.sales_date)}}</small>
                            </b-checkbox>
                            <b-checkbox
                              unchecked-value="0"
                              value="1"
                              v-model="exchange_rate_details.recalc"
                              class="mt-2"
                            >
                              <small>Re-calculate item prices based on this rate</small>
                            </b-checkbox>
                          </b-col>
                        </b-row>
                        <b-row class="mt-3">
                          <b-col>
                            <b-button variant="primary" size="xs" @click="exchangeRateSubmit()">Save</b-button>
                          </b-col>
                        </b-row>
                      </b-dropdown-form>
                    </b-dropdown>
                  </span>
                </span>
              </span>
              <template v-else>
                <b-form-group
                  label="Exchange rate"
                  label-class="required"
                  label-cols="4"
                  label-for="currency"
                >
                  <b-input-group
                    size="sm"
                    :append="orgCurrency"
                    :prepend="'1 '+getDetails(
                    this.$AppDetails.currency_details,
                    field.cus_currency,
                    'currency_code'
                    ) +' = '"
                  >
                    <b-form-input
                      @blur="changeExchangeRate()"
                      type="text"
                      class="text-right"
                      v-model.trim="field.unit_currency_value"
                      name="Currency"
                      data-vv-name="currency"
                      v-validate="'required|decimal:5|excluded:'+parseFloat(0).toFixed(2)+'|min_value:0'"
                    ></b-form-input>
                  </b-input-group>
                  <small
                    v-if="org_details.exchange_rate_status==1"
                    class="text-muted"
                  >This will be set as the exchange rate for this date.</small>
                </b-form-group>
              </template>
            </span>
          </b-col>
        </div>
      </div>

      <div class="mt-3">
        <b-row style="max-width:1400px;">
          <b-col xl="12" lg="12" md="12" sm="12" xs="12">
            <table class="table table-bordered sales-table last-child-border-none">
              <thead>
                <!-- <th width="1%">#</th> -->
                <th>Product Name</th>
                <th width="12%" class="text-right">Quantity</th>
                <th width="12%" class="text-right">Price</th>
                <th width="15%" class="text-right" v-if="field.discount_cat == 1">Discount</th>
                <th width="18%" v-if="org_details.gst_type == 1&&type=='invoice'">
                  Tax
                  <small>{{ field.is_tax_reverse_charge == 1 ? '(Reverse Charge)' : '' }}</small>
                </th>

                <th class="text-right" width="14%">Subtotal</th>
                <th width="1%"></th>
              </thead>
              <tbody>
                <tr v-for="(item,index) in items" :key="index" class="table-tr-input">
                  <!-- <td>{{ index + 1 }}</td> -->
                  <!-- product selection on seartch usign watch funciton -->
                  <td @click="removeproduct($event,index)" class="show-product-details">
                    <span class="d-flex">
                      <input
                        v-show="item.sal_itm_id || item.cnvt_crdt_qty > 0 || item.cnvt_crdt_rtn_qty > 0"
                        type="text"
                        class="form-control mr-3"
                        :value="item.pdt_detail_id"
                        disabled
                      />
                      <vue-bootstrap-typeahead
                        v-show="!item.sal_itm_id&& item.cnvt_crdt_qty <= 0 && item.cnvt_crdt_rtn_qty <= 0"
                        style="width:100%"
                        @input="productlist($event,index)"
                        v-model="item.pdt_detail_id"
                        :id="'vuebootsearcher'+index"
                        name="pdt_detail_id[]"
                        :data="item.products"
                        :class="{'is-invalid': errors.has('pdt_detail_id'),'mr-3 table-form-search':true,'product_search':true}"
                        :serializer="product => product.label+' '+product.pdt_legacy_id+' '+product.pdt_sku"
                        @hit="checkSalePrice($event,index)"
                        placeholder="Type to search product"
                        :ref="'pdt_name_typeahead_'+index"
                      >
                        <template slot="suggestion" slot-scope="{ data, htmlText }">
                          <span>{{ data.label }}</span>
                          <br />

                          <small class="pr-3" v-if="data.pdt_legacy_id">{{data.pdt_legacy_id }}</small>
                          <small>{{ data.pdt_sku }}</small>
                        </template>
                      </vue-bootstrap-typeahead>

                      <b-form-input
                        v-show="false"
                        type="text"
                        size="sm"
                        :name="'pdt_id['+index+']'"
                        v-model.trim="item.pdt_id"
                        :data-vv-name="'row '+(index +1)+' product'"
                        v-validate="'required'"
                      />
                      <span>
                        <b-dropdown variant="outline-light text-dark" no-caret size="xs">
                          <template slot="button-content">
                            <i class="glyphicon glyphicon-option-vertical"></i>
                          </template>
                          <div class="dropdownitem-list">
                            <b-dropdown-item
                              v-show="!item.sal_itm_id && item.cnvt_crdt_qty <= 0 && item.cnvt_crdt_rtn_qty <= 0"
                              v-if="RoutePermission(false,'','invoice','product','create')"
                              v-b-modal.createproduct
                              v-on:click="item_id = index"
                            >Add product</b-dropdown-item>
                            <b-dropdown-item v-b-toggle="'product-detail'+index">Add details</b-dropdown-item>
                          </div>
                        </b-dropdown>
                      </span>
                    </span>
                    <!-- <span
                          class="float-right table-custom-info-icon cursor_pointer"
                          v-b-tooltip
                          title="Add Details"
                          v-b-toggle="'product-detail'+index"
                        >
                          <i class="la la-info-circle mt-1 ml-1 la-lg"></i>
                        </span>
                        <span
                          v-show="!item.sal_itm_id && item.cnvt_crdt_qty <= 0 && item.cnvt_crdt_rtn_qty <= 0"
                          v-if="RoutePermission(false,'','invoice','product','create')"
                          class="float-right table-custom-add-icon cursor_pointer"
                          v-b-tooltip
                          title="Add Product"
                          v-b-modal.createproduct
                          v-on:click="item_id = index"
                    >&#43;</span>-->
                    <b-collapse :id="'product-detail'+index">
                      <!--  pdt hsn desc -->
                      <textarea
                        placeholder="Description"
                        :data-vv-name="'row '+(index +1)+' product description'"
                        v-validate="'max:255'"
                        class="form-control mt-1 item_table_desc"
                        v-model.trim="item.pdt_desc"
                        :name="'pdt_desc['+index+']'"
                        rows="2"
                      ></textarea>
                      <small class="theme-text-color fw-semi-bold display-flex">
                        <!--  pdt hsn details -->
                        <span class="mt-2 pt-1">HSN / SAC:</span>
                        <span>
                          <input
                            class="form-control mt-2 ml-2 p-1 mb-2"
                            :data-vv-name="'row '+(index +1)+' HSN/SAC'"
                            v-validate="'max:8|numeric'"
                            type="text"
                            v-model.trim="item.pdt_hsn"
                            :name="'pdt_hsn['+index+']'"
                            style="width:100px;height:20px !important;"
                          />
                        </span>
                      </small>

                      <span class="badge badge-primary pt-1 product-state">{{ item.pdt_state }}</span>
                    </b-collapse>
                  </td>
                  <td style="width:12%;word-break:break-word">
                    <!--  pdt qty details -->

                    <input
                      v-model.trim="item.pdt_qty"
                      :data-vv-name="'row '+(index +1)+' product quantity'"
                      :name="'pdt_qty['+index+']'"
                      @blur="roundOffItem(index,'pdt_qty',6)"
                      v-validate="(item.pdt_cat == 2?'numeric|':'')+'required'"
                      :class="{ 'form-control': true,'text-right':true,'is-invalid': errors.has('pdt_qty')}"
                      type="text"
                      id="pdt_qty"
                    />

                    <small class="float-right theme-text-color">{{ item.unit_name }}</small>
                    <br />
                    <span v-if="item.sal_itm_id">
                      <small
                        class="theme-text-color float-right"
                      >Qty Ordered : {{ Number(item.qty_limit.ordered_qty) }}</small>
                      <br />
                      <small
                        class="theme-text-color float-right"
                      >Qty Invoiced : {{ Number(item.qty_limit.invoiced_qty) }}</small>
                      <br />
                    </span>

                    <!-- <span
                          class="float-right text-sm"
                          v-if="item.is_inventory == 1 && item.pdt_id && item.locationdetails && item.locationdetails[item.warehouse_id]"
                        >
                          Hand Stock :{{ item.locationdetails[item.warehouse_id]["phy_stock_details"].good_on_hand }}
                          <br />
                          <span class="theme-text-color" @click="callsingleitemrowmodal(item)">
                            <i class="fa fa-home"></i>
                            {{ item.locationdetails[item.warehouse_id].warehouse_name }}
                          </span>
                          <br />
                          <div
                            class="theme-text-color mt-2"
                            style="font-size:11px"
                            v-if="item.pdt_cat == 2"
                            @click="callsingleitemserialrowmodal(item)"
                          >
                            <input
                              type="hidden"
                              v-model.trim="item.pdt_serial_nos"
                              v-validate="'required'"
                              :data-vv-name="'row '+(index +1)+' product serial no'"
                            />
                            <input
                              type="hidden"
                              :value="item.pdt_serial_nos.length"
                              :ref="'productserialnolength['+index+']'"
                              :data-vv-name="'row '+(index +1)+' product serial no length'"
                            />
                            <input
                              type="hidden"
                              :value="parseInt(item.pdt_qty)"
                              name="qty[]"
                              v-validate="'required|confirmed:productserialnolength['+index+']'"
                              :data-vv-name="'row '+(index +1)+' serial no and quantity'"
                            />

                            <template v-if="item.pdt_serial_nos.length == 0">
                              <i class="fa fa-warning text-danger"></i>Select
                            </template>
                            <template v-else>{{ item.pdt_serial_nos.length }}</template> Serial Number(s)
                          </div>
                    </span>-->
                  </td>
                  <td>
                    <!--  pdt unit price details -->

                    <input
                      v-validate="'required'"
                      @blur="roundOffItem(index,'unit_price',6)"
                      v-model.trim="item.unit_price"
                      :data-vv-name="'row '+(index +1)+' unit price'"
                      :name="'unit_price['+index+']'"
                      :class="{ 'form-control': true ,'text-right':true,'is-invalid': errors.has('unit_price')}"
                      type="text"
                      id="unit_price"
                    />
                    <!-- price list dropdown -->
                    <v-select
                      class="form-vselect"
                      label="label"
                      index="value"
                      style="margin-top:5px;"
                      data-vv-name="price list"
                      id="search-select"
                      @input="calculatepricelist([item.pdt_id],$event,'sales',[index])"
                      v-if="item.pdt_id&&enablepricelist.is_price_list_enabled == 1 && price_list.length > 0 && (enablepricelist.is_item_level_price_list_enabled == 1||(page=='update'&&list.is_price_id_exist==1))"
                      v-model.trim="item.pricing_hdr_id"
                      size="sm"
                      placeholder="Price List"
                      :name="'price_list['+index+']'"
                      :options="pricelistgenerate"
                    >
                      <template slot="option" slot-scope="option">
                        <div class="d-flex w-100 v-select-option" :title="option.label">
                          <div class="text-truncate" style="width:100%">{{ option.label }}</div>
                        </div>
                      </template>
                    </v-select>
                    <span
                      v-if="item.pricing_hdr_id&&item.slab_min_qty&&(item.pdt_qty<item.slab_min_qty||(item.slab_max_qty!=null&&item.pdt_qty>item.slab_max_qty))"
                      class="fa fa-info-circle float-right text-warning mt-1"
                      v-b-tooltip.bottom="'The default rate has been applied as the quantity is '+ (item.pdt_qty<item.slab_min_qty?'less':'more') +' than the range mentioned in the selected price list'"
                    ></span>
                  </td>
                  <td v-if="field.discount_cat == 1">
                    <b-row>
                      <!--  pdt discount details -->
                      <b-col class="pr-0" xl="8" lg="7" md="6" sm="6" xs="6">
                        <input
                          :data-vv-name="'row '+(index +1)+' product discount amount'"
                          v-validate="{'required':true,'decimal':2,'min_value':0,'max_value':item.is_percent == 0?parseFloat(item.unit_price*item.pdt_qty).toFixed(2):100}"
                          v-model.trim="item.discount_amount"
                          :name="'pdt_discount_amount['+index+']'"
                          :class="{ 'form-control': true,'text-right':true,'is-invalid': errors.has('discount_amount')}"
                          type="text"
                          id="basic"
                        />
                      </b-col>
                      <b-col class="pl-0" xl="4" lg="5" md="6" sm="6" xs="6">
                        <select
                          v-model.trim="item.is_percent"
                          name="is_percent[]"
                          class="form-control"
                          style="padding:2px !important;border-left:0 !important"
                        >
                          <option value="0">
                            {{ getDetails(
                            $AppDetails.currency_details,
                            (field.cus_currency || $AppDetails.organization.org_currency),
                            "currency_symbol"
                            ) }}
                          </option>
                          <option value="1">%</option>
                        </select>
                      </b-col>
                    </b-row>
                  </td>
                  <td
                    :class="{'unselectable':field.tax_exempt == 1}"
                    v-if="org_details.gst_type == 1&&type=='invoice'"
                  >
                    <!--  pdt tax  details -->
                    <b-form-select
                      style="padding:2px;padding-right:31px !important;"
                      :class="{'form-control':true}"
                      v-model.trim="item.tax_id"
                      :name="'tax_id['+index+']'"
                      v-if="checkstate()"
                      @change="item.exempt_reason_id=''"
                      :disabled="(typeof field.cus_id == 'undefined' || field.cus_id == '' )"
                      v-validate="'required'"
                      data-vv-name="tax"
                    >
                      <option
                        v-for="(tax, index) in tax_list"
                        :key="index"
                        v-if="tax.tax_state != 2 && (field.is_tax_reverse_charge == 0 || (field.is_tax_reverse_charge == 1 && tax.tax_id != 19))&&tax.status!=0||tax.tax_id==item.tax_id"
                        :value="tax.tax_id"
                      >
                         <span>{{ tax.status!=0?tax.tax_name+' ['+tax.tax_percent+' %]': tax.tax_name+' ['+tax.tax_percent+' %] *'}}</span>
                      </option>
                    </b-form-select>
                    <b-form-select
                      style="padding:2px;padding-right:31px !important;"
                      class="text-truncate"
                      v-validate="'required'"
                      :data-vv-name="'row '+(index +1)+' tax'"
                      :class="{'form-control':true}"
                      v-model.trim="item.tax_id"
                      @change="item.exempt_reason_id=''"
                      :name="'tax_id['+index+']'"
                      v-else
                      :disabled="(typeof field.cus_id == 'undefined' || field.cus_id == '' )"
                    >
                      <option
                        v-for="(tax, index) in tax_list"
                        :key="index"
                        v-if="tax.tax_state != 1 && (field.is_tax_reverse_charge == 0 || (field.is_tax_reverse_charge == 1 && tax.tax_id != 20))&&tax.status!=0||tax.tax_id==item.tax_id"
                        :value="tax.tax_id"
                      >
                         <span>{{ tax.status!=0?tax.tax_name+' ['+tax.tax_percent+' %]': tax.tax_name+' ['+tax.tax_percent+' %] *'}}</span>
                      </option>
                    </b-form-select>
                    <template v-if="item.tax_id==19||item.tax_id==20">
                      <b-input-group class="vselect-custom-add mt-1">
                        <template slot="append">
                          <b-input-group-text
                            class="vselect-custom-add-icon mt-1"
                            style="border-color:#f5f5f5 !important"
                            v-b-tooltip
                            title="Add Exempt"
                            v-on:click="excemptmodal=true,
                    exempt_index = index,
                    callexemptmodal({value:'',label:''})"
                          >&#43;</b-input-group-text>
                        </template>
                        <template slot="prepend">
                          <v-select
                            :clearable="false"
                            size="sm"
                            v-validate="'required'"
                            v-model="item.exempt_reason_id"
                            class="mt-1 form-vselect"
                            index="value"
                            label="label"
                            :options="exempt_reason_list"
                            title="tax exempt reason"
                            :data-vv-name="'row '+(index +1)+' exempt reason'"
                          >
                            <template slot="option" slot-scope="option">
                              <div class="d-flex w-100 v-select-option" :title="option.label">
                                <div class="text-truncate" style="width:100%">{{ option.label }}</div>
                              </div>
                            </template>
                          </v-select>
                        </template>
                      </b-input-group>
                    </template>
                  </td>
                  <td
                    class="text-right"
                  >{{ (item.pdt_id != "" && typeof item.pdt_id != 'undefined') ? Number(computeSubTotal(item)).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) : "" }}</td>
                  <td>
                    <div class="d-inline d-flex pt-2">
                      <!-- button for reporting tag modal -->
                      <i
                        class="la la-tags la-lg cursor_pointer"
                        v-b-tooltip
                        title="Add Reporting Tags"
                        @click="callreportingmodal(item)"
                      ></i>
                      <!-- button for remove item line -->
                      <i
                        class="glyphicon glyphicon-trash pl-1 cursor_pointer"
                        v-if="item.cnvt_crdt_qty <= 0 && item.cnvt_crdt_rtn_qty <= 0"
                        @click="removeRow(index)"
                      ></i>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td class="no-border">
                    <p
                      class="mb-1 pt-2 addline theme-text-color cursor_pointer"
                      @click="addNewRow()"
                      v-if="!$route.query.sales_order&&!$route.query.quotation"
                    >Add Lines</p>
                    <p
                      class="mb-1 pt-2 addline theme-text-color cursor_pointer"
                      @click="updatedatafromsalesorder()"
                      v-if="this.page == 'update' && $route.query.sales_order && itemfromsalesorder"
                    >Add from sales order</p>
                  </td>
                  <td
                    :colspan="(org_details.gst_type == 1 &&type=='invoice') && field.discount_cat == 1?4:org_details.gst_type != 1 && field.discount_cat != 1?2:3"
                    class="no-border text-right"
                  >
                    <p class="mb-1 pt-2">Subtotal {{ field.tax_type_id == 1 ? '(Inclusive)' : '' }}</p>
                  </td>
                  <td class="no-border text-right">
                    <p
                      class="mb-1 pt-2 mr-2"
                    >{{ Number(total.incl_total_without_tax).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</p>
                  </td>
                </tr>
                <tr v-if="org_details.gst_type == 1">
                  <td
                    :colspan="(org_details.gst_type == 1 &&type=='invoice') && field.discount_cat == 1?5:org_details.gst_type != 1 && field.discount_cat != 1?3:4"
                    class="no-border text-right"
                  >
                    <p class="mb-1">Subtotal (without tax)</p>
                  </td>
                  <td class="no-border text-right">
                    <p
                      class="mr-2 mb-1"
                    >{{ Number(total.total_without_tax).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</p>
                  </td>
                </tr>
                <tr>
                  <td
                    :colspan="(org_details.gst_type == 1 &&type=='invoice') && field.discount_cat == 1?5:org_details.gst_type != 1 && field.discount_cat != 1?3:4"
                    class="no-border text-right"
                  >
                    <p
                      v-for="taxlist in splitted_tax"
                      v-if="taxlist != null && field.discount_cat == 3"
                      style="font-size:0.8675rem !important"
                      class="mb-1"
                      :key="taxlist.id"
                    >
                      {{ taxlist[0].label }}
                      <span
                        class="text-sm"
                      >( {{parseFloat(taxlist[0].taxable).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }} )</span>
                    </p>
                  </td>
                  <td class="no-border text-right">
                    <p
                      v-for="taxlist in splitted_tax"
                      v-if="taxlist != null && field.discount_cat == 3 "
                      class="mb-1 mr-2"
                      :key="taxlist.id"
                    >{{ Number(taxlist[0].value).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</p>
                  </td>
                </tr>

                <tr v-if="field.discount_cat == 2 || field.discount_cat ==3">
                  <td
                    :colspan="(org_details.gst_type == 1 &&type=='invoice') && field.discount_cat == 1?4:org_details.gst_type != 1 && field.discount_cat != 1?2:3"
                    class="no-border text-right"
                  >
                    <p class="mt-2">
                      Discount
                      <span
                        style="font-size: 10px;"
                      >({{ Number(total.total_without_tax).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }})</span>
                    </p>
                  </td>
                  <td class="no-border text-right">
                    <span class="d-flex float-right">
                      <input
                        v-validate="{'required':true,'decimal':2,'min_value':0,'max_value':field.is_discount_percent == 0?field.discount_cat == 2 ?total.total_without_tax:parseFloat(parseFloat(total.total_without_tax)+parseFloat(total.tax_total_value)).toFixed(2):100}"
                        v-model.trim="field.discount_amount"
                        name="Discount amount"
                        data-vv-name="discount amount"
                        :class="{ 'form-control bord-bottom-input  float-right': true,'text-right':true,'is-invalid': errors.has('Discount amount')}"
                        type="text"
                        id="basic"
                        class="text-right"
                      />
                      <select
                        v-model.trim="field.is_discount_percent"
                        name="is_percent[]"
                        class="form-control text-right bord-bottom-input float-right"
                        style="padding:8px !important;width:50px"
                      >
                        <option value="0">
                          {{ getDetails(
                          $AppDetails.currency_details,
                          (field.cus_currency || $AppDetails.organization.org_currency),
                          "currency_symbol"
                          ) }}
                        </option>
                        <option value="1">%</option>
                      </select>
                    </span>
                  </td>
                  <td class="no-border text-right">
                    <p
                      class="mb-4 mr-2"
                      style="position: relative;top: 8px;"
                    >(-) {{ Number(total.total_discount_amount).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</p>
                  </td>
                </tr>

                <tr>
                  <td
                    :colspan="(org_details.gst_type == 1 &&type=='invoice') && field.discount_cat == 1?5:org_details.gst_type != 1 && field.discount_cat != 1?3:4"
                    class="no-border text-right"
                  >
                    <p
                      v-for="taxlist in splitted_tax"
                      v-if="taxlist != null && field.discount_cat != 3 "
                      style="font-size:0.8675rem !important"
                      class="mb-1"
                      :key="taxlist.id"
                    >
                      {{ taxlist[0].label }}
                      <span
                        class="text-sm"
                      >( {{parseFloat(taxlist[0].taxable).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }} )</span>
                    </p>
                  </td>
                  <td class="no-border text-right">
                    <p
                      v-for="taxlist in splitted_tax"
                      v-if="taxlist != null && field.discount_cat != 3 "
                      class="mb-1 mr-2"
                      :key="taxlist.id"
                    >{{ Number(taxlist[0].value).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</p>
                  </td>
                </tr>

                <tr v-if="field.is_adjustment">
                  <td
                    :colspan="(org_details.gst_type == 1 &&type=='invoice') && field.discount_cat == 1?4:org_details.gst_type != 1 && field.discount_cat != 1?2:3"
                    class="no-border text-right"
                  >
                    <input
                      type="text"
                      class="form-control bord-bottom-input float-right"
                      placeholder="Adjustments"
                      name="adjustment_name"
                      data-vv-name="adjustment name"
                      v-model.trim="field.adjustment_name"
                      v-validate="'max:30'"
                    />
                  </td>
                  <td class="no-border text-right">
                    <input
                      style="border: unset !important;border-bottom: 1px dashed #e0e0e0 !important;width: 150px !important;"
                      @blur="roundOff('adjustments',2)"
                      type="text"
                      class="form-control bord-bottom-input text-right float-right"
                      name="adjusted_amount"
                      data-vv-name="adjusted amount"
                      v-model.trim="field.adjustments"
                      v-validate="'max:10|decimal:2'"
                    />
                  </td>
                  <td class="no-border text-right">
                    <p
                      class="mb-4 mr-2"
                      style="position: relative;top: 8px;"
                    >{{ !isNaN(field.adjustments) && field.adjustments != '' ? Number(field.adjustments).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) : 0 }}</p>
                  </td>
                </tr>
                <tr v-if="field.is_shipping_charge">
                  <td
                    :colspan="(org_details.gst_type == 1 &&type=='invoice') && field.discount_cat == 1?5:org_details.gst_type != 1 && field.discount_cat != 1?3:4"
                    class="no-border text-right"
                  >
                    <p class="mt-2">Shipping Charge</p>
                  </td>
                  <td class="no-border text-right">
                    <b-input
                      style="border: unset !important;border-bottom: 1px dashed #e0e0e0 !important;width: 100px !important;"
                      v-validate="'max:10|min_value:0'"
                      class="form-control bord-bottom-input text-right float-right"
                      data-vv-name="shipping amount"
                      @blur="roundOff('shipping_amount',2)"
                      v-model.trim="field.shipping_amount"
                    ></b-input>
                  </td>
                </tr>
                <tr>
                  <td
                    :colspan="(org_details.gst_type == 1 &&type=='invoice') && field.discount_cat == 1?5:org_details.gst_type != 1 && field.discount_cat != 1?3:4"
                    class="no-border text-right"
                  >
                    <p class="pt-2 mb-4">
                      <strong>
                        {{field.discount_cat != 4 ?'Total with Discount' :'Total'}} ( {{ getDetails(
                        $AppDetails.currency_details,
                        (field.cus_currency || $AppDetails.organization.org_currency),
                        "currency_symbol"
                        ) }} )
                      </strong>
                    </p>
                  </td>
                  <td class="no-border text-right">
                    <p class="mb-4 mr-2 pt-2">
                      <strong>{{ Number(total.total_with_adjustments).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 }) }}</strong>
                    </p>
                    <b-input v-show="false" data-vv-name="total amount" v-model="total.total_with_adjustments" v-validate="'min_value:0'"></b-input>
                  </td>
                </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
      </div>
      <!--  adding iatem line details -->

      <br />

      <!--  remaining header details blcok -->
      
      <b-row style="max-width:1170px;">
        <b-col xl="12" lg="12" md="12" sm="12" xs="12">
          <b-form-group class="mt-1 pb-2">
            <!--  invoice extra notes -->
            <b-row>
              <b-col xl="7" lg="10" md="12" sm="12" xs="12">
                <label for="datetimepicker">Customer Notes</label>
                <b-form-textarea
                  v-model="field.cus_inv_notes"
                  @input="inv_desc_changed=true"
                  name="cus_inv_notes"
                  :rows="4"
                  id="cus_inv_notes"
                  data-vv-name="customer notes"
                  v-validate="'max:255'"
                />
                <b-form-checkbox
                  v-if="inv_desc_changed==true"
                  id="inv_desc_changed"
                  v-model.trim="field.inv_desc_changed"
                  name="inv_desc_changed"
                  value="1"
                  unchecked-value="0"
                >Use this in future.</b-form-checkbox>
              </b-col>
            </b-row>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row style="max-width:1170px;" class="pb-3">
        <b-col xl="12" lg="12" md="12" sm="12" xs="12">
          <b-form-group class="mt-1">
            <b-row>
              <!-- terms and conditaion -->
              <b-col xl="7" lg="10" md="12" sm="12" xs="12">
                <label for="datetimepicker">Terms and Conditions</label>
                <b-form-textarea
                  v-model="field.internal_notes"
                  name="internal_notes"
                  :rows="4"
                  id="internal_notes"
                  data-vv-name="terms and condition"
                  v-validate="'max:1000'"
                  @input="inv_term_changed=true"
                />
                <b-form-checkbox
                  v-if="inv_term_changed==true"
                  id="inv_term_changed"
                  v-model.trim="field.inv_term_changed"
                  name="inv_term_changed"
                  value="1"
                  unchecked-value="0"
                >Use this in future.</b-form-checkbox>
              </b-col>
            </b-row>
          </b-form-group>
        </b-col>
      </b-row>

      <!-- footer block -->
      <div class="footer" style="box-shadow:0 0 5px #ccc;">
        <div :class="{'form-action' : true}">
          <b-button
            @click="button_id = 1;inv_status = 1; pageredirect =''"
            type="submit"
            variant="primary"
            class="btn-rounded mr-3"
            :disabled="submitted"
          >
            <i v-if="button_id==1&&submitted" class="fa fa-circle-o-notch fa-spin mr-2"></i>Save
          </b-button>

          <b-dropdown
            v-if="RoutePermission(false,'','','invoice','approve')||RoutePermission(false,'','invoice','paymentsreceived','create')"
            @click="button_id=2;onSubmit('amc-invoice-form') ;inv_status = 2;pageredirect = ''"
            size="sm"
            class="btn-rounded mr-3"
            variant="primary"
            split
            :disabled="submitted"
          >
            <template slot="button-content" v-if="RoutePermission(false,'','','invoice','approve')">
              <i v-if="button_id==2&&submitted" class="fa fa-circle-o-notch fa-spin mr-2"></i>Save and Approve
            </template>
            <b-dropdown-item
              v-if="RoutePermission(false,'','invoice','paymentsreceived','create')"
              @click="onSubmit('amc-invoice-form') ;button_id=2;inv_status = 2;pageredirect = 'payment'"
            >Save and Record Payment</b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
    </b-form>

    <ProductModal v-on:setProductValue="getProductValue($event)" :item-id="item_id"></ProductModal>
    <TagModal
      v-if="invoicetagmodal"
      :tag_id="modal_tag_id"
      module="sales"
      v-on:setMultipleAddedRef="getMultipleAddedRef"
    ></TagModal>
    <SalesPersonModal :sales_person_id="modal_sales_person_id" v-on:setAddedRef="getAddedRef"></SalesPersonModal>
    <ProjectModal :pjt_id="modal_pjt_id" v-on:setAddedRefproject="getAddedRefproject"></ProjectModal>
    <AutoGenerateCode v-on:setCodeValue="getCodeValue($event)" :type="field.type||'invoice'"></AutoGenerateCode>
    <locationdetailpreview :singleitemrow="singleitemrow" />
    <AdditionalAddress
      v-on:setcustomerAddAddress="customerAddAddress"
      :page="this.addresspage"
      :field="cus_add_address"
      addresstype="form"
      :customeraddress="this.cusaddress"
    ></AdditionalAddress>
    <DeleteDropdown
      v-if="invoicetagdelete || salespersondelete||salesprojectdelete"
      id="invoice-dropdown-delete"
      :content="'Are you sure you want to delete this'+(salespersondelete?' sales person ?':salesprojectdelete?' project ?':' selected tag ?')"
      module="general"
      :method="invoicetagdelete?'salestagdelete':salesprojectdelete?'salesprojectdelete':'salespersondelete'"
      v-on:setDropdownDelete="getDropdownDelete"
      :value="deletedropdownid"
    ></DeleteDropdown>

    <ShowCustomerDetails v-if="customer_details == 1"></ShowCustomerDetails>
    <ShowCustomerAddressDetails
      v-on:setcustomerAddress="customerAddress"
      :field="cusaddress"
      :address="customeraddress"
    ></ShowCustomerAddressDetails>
    <!--  reporting tag modal -->
    <ReportingTag :singleitemrow="singleitemrow" :data="item_reporting_tag" />
    <b-modal
      v-model="show_credit_modal"
      title="Credit Limit exceeded"
      id="credit_exceeded"
      ref="credit_limt_modal"
      :ok-title-html="(submitted==true?loaderIcon:'')+(updatecredit==1?'Update and Save':cus_settings_details.cus_credit_limit &&cus_settings_details.cus_credit_limit.enable == 1&&cus_settings_details.cus_credit_limit.restrict == 1?'Ok':'Proceed')"
      @ok.prevent="customerCreditLimt('credit_form')"
      :no-close-on-backdrop="true"
      cancel-variant="light"
      @shown="updatecredit=0;credit_limit=0"
      :ok-disabled="submitted"
    >
      <b-form data-vv-scope="credit_form">
        <p>
          Credit Limit for the customer has exceeded the set value. Do you still want to proceed?
          <span
            v-b-toggle.credit_limit_details
            class="text-link cursor_pointer"
          >{{view_credit_limit?'Hide details':'View details'}}</span>
        </p>
        <b-collapse id="credit_limit_details" v-model="view_credit_limit">
          <table class="w-100 mb-2">
            <tbody>
              <tr>
                <td>
                  Outstanding Receivables
                  <small class="d-block" v-if="unused_credits>0">
                    {{'(Including unused credits '+getDetails(
                    $AppDetails.currency_details,
                    (field.cus_currency || $AppDetails.organization.org_currency),
                    "currency_symbol"
                    )+' '+unused_credits+')'}}
                  </small>
                </td>
                <td class="text-right">
                  {{ getDetails(
                  $AppDetails.currency_details,
                  (field.cus_currency || $AppDetails.organization.org_currency),
                  "currency_symbol"
                  )+' '+Number(Math.abs(parseFloat(total_due_amt)-parseFloat(unused_credits)- (field.inv_status == 1
                  ? 0
                  : parseFloat(inv_grand_total)))).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 })}}
                </td>
              </tr>
              <tr>
                <td>Invoice amount</td>
                <td class="text-right">
                  {{getDetails(
                  $AppDetails.currency_details,
                  (field.cus_currency || $AppDetails.organization.org_currency),
                  "currency_symbol"
                  )+' '+Number(total.total_with_adjustments).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 })}}
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <hr class="m-0" />
                </td>
              </tr>
              <tr>
                <td>Total Outstanding Receivables</td>
                <td class="text-right">
                  {{getDetails(
                  $AppDetails.currency_details,
                  (field.cus_currency || $AppDetails.organization.org_currency),
                  "currency_symbol"
                  )+' '+Number(Math.abs(parseFloat(total.total_with_adjustments)+parseFloat(total_due_amt)-parseFloat(unused_credits)- (field.inv_status == 1
                  ? 0
                  : parseFloat(inv_grand_total)))).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 })}}
                </td>
              </tr>
              <tr>
                <td>Customer Credit Limit</td>
                <td class="text-right">
                  {{getDetails(
                  $AppDetails.currency_details,
                  (field.cus_currency || $AppDetails.organization.org_currency),
                  "currency_symbol"
                  )+' '+Number(cus_credit_limit).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 })}}
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <hr class="m-0" />
                </td>
              </tr>
              <tr class="text-danger">
                <td>Exceeded Amount</td>
                <td class="text-right">
                  {{getDetails(
                  $AppDetails.currency_details,
                  (field.cus_currency || $AppDetails.organization.org_currency),
                  "currency_symbol"
                  )+' '+Number(Math.abs(parseFloat(total.total_with_adjustments)+parseFloat(total_due_amt)-parseFloat(unused_credits)-parseFloat(cus_credit_limit)- (field.inv_status == 1
                  ? 0
                  : parseFloat(inv_grand_total)))).toLocaleString(undefined, { minimumFractionDigits: 2,maximumFractionDigits:2 })}}
                </td>
              </tr>
            </tbody>
          </table>
        </b-collapse>
        <div v-if="updatecredit!=1" class="px-2">
          <span class="cursor_pointer text-link" @click="updatecredit=1">Update Credit Limit</span>
        </div>
        <div class="px-2" v-else>
          <b-form-group horizontal :label-cols="4" label-for="credit_limit" label="Credit Limit">
            <b-input-group :prepend="orgCurrency" class="mb-2 mr-sm-2 mb-sm-0 product_currency">
              <b-input
                data-vv-name="credit_limit"
                v-validate="'decimal:2|min_value:0.01|max_value:100000000000000'"
                @blur="roundOffDirect('credit_limit',2)"
                v-model.trim="credit_limit"
                :class="{ 'form-control': true}"
                type="text"
              />
              <span
                class="fw-semi-bold text-danger"
                v-if="cus_credit_error&&errors.has('credit_form.credit_limit')"
              >Please enter a valid Credit Limit Amount</span>
            </b-input-group>
          </b-form-group>
        </div>
      </b-form>
    </b-modal>
    <b-modal
      id="bill_of_supply"
      ref="bill_of_supply"
      size="md"
      body-class="bg-white"
      cancel-title="Cancel"
      cancel-variant="light"
      :ok-title-html="submitted==true&&button_id==3?loaderIcon+'Yes':'Yes'"
      :ok-disabled="submitted"
      @ok="button_id=3;onSubmit('invoice-form')"
      title="Bill Of Supply"
    >You can create a Bill of Supply instead of an invoice for non-taxable goods/services. Do you still want to save it as an invoice?</b-modal>
    <GlobalAlertModal
      :title="globaltitle"
      :content="globalcontent"
      :callback="globalcallsuccess"
      v-on:setAlertSuccess="alertsuccessglobalmodal"
    />
    <!-- Modal for change exchange rate value change warning message -->

    <ExchangeRateWarning></ExchangeRateWarning>
    <ExemptReason
      v-if="excemptmodal"
      :exempt_reason="modal_exempt_reason"
      module="products"
      v-on:setMultipleAddedRefExempt="getMultipleAddedRefExempt"
    ></ExemptReason>
  </div>
</template>
<script scoped>
// import all the components, files and funciton
import CustomPreview from "@/components/Form/Settings/CustomPreview";
import { pricelist } from "@/mixins/pricelist"; // pricing list fnction
import moment from "moment"; // to control date format
import VueBootstrapTypeahead from "vue-bootstrap-typeahead"; // data on search api calls
import { mapState, mapGetters } from "vuex"; // get data set in the state in vuex
import store from "@/store/index"; // vuex store fucntion
import { notificationMixin } from "@/mixins/notification"; // global fucntion for calling notification
import { formatDate } from "@/mixins/formatDate"; // global fucntion for calling formatDate
import ProductModal from "@/components/Modal/ProductModal"; // product modal
import TagModal from "@/components/Modal/TagModal"; // tag modal
import ProjectModal from "@/components/Modal/ProjectModal"; // project modal
import AdditionalAddress from "@/components/Form/Customer/AdditionalAddress"; // credits available modal\
import SalesPersonModal from "@/components/Modal/SalesPersonModal"; // sales person modal modal
import DatePicker from "vue2-datepicker"; // vue datepicker
import locationdetailpreview from "@/components/Modal/LocationDetailModal";
import $ from "jquery"; // for using jquery function
import vSelect from "vue-select"; // searchable select dropdwon
import AutoGenerateCode from "@/components/Modal/AutoGenerateCode";
import DeleteDropdown from "@/components/Modal/DeleteDropdown";
import ShowCustomerDetails from "@/components/Form/Customer/ShowCustomerDetails";
import ShowCustomerAddressDetails from "@/components/Form/Customer/ShowCustomerAddressDetails";
import { EventBus } from "@/event-bus.js"; // call bus event to access child component method from parent component
import ReportingTag from "@/components/Modal/Product/ReportingTag"; //for reporting tag modal component
import ExchangeRateWarning from "@/components/Modal/ExchangeRateWarning"; //for Exchange rate change warning message in modal
import ExemptReason from "@/components/Modal/ExemptReason";

export default {
  props: ["page", "duplicatecode", "submitted"],
  mixins: [notificationMixin, formatDate, pricelist], // call the glbal mixin fucntion
  name: "InvoiceCreate", // page name
  components: {
    AutoGenerateCode, // modal for auto generated code
    DatePicker, // datepciker
    VueBootstrapTypeahead, // on change api
    ProductModal, // product create modal
    TagModal, // tag create modal
    SalesPersonModal, // sales prson crearte cmodal
    ProjectModal, // project create modal
    vSelect,
    AdditionalAddress,
    DeleteDropdown,
    ShowCustomerDetails,
    ShowCustomerAddressDetails,
    locationdetailpreview,
    CustomPreview,
    ReportingTag, // reporting tag modal
    ExchangeRateWarning, //modal component for exchange rate changes
    ExemptReason
  },
  data() {
    return {
      type: "invoice",
      view_credit_limit: false,
      cus_credit_error: false,
      bill_of_supply: false,
      contactremoved: false,
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      globaltitle: "",
      globalcontent: "",
      globalcallsuccess: false,
      addresspage: "",
      inv_status: "",
      amcinvCollapse: "",
      inv_desc_changed: false,
      inv_term_changed: false,
      invoicetagmodal: false,
      invoicetagdelete: false,
      singleitemrow: {},
      reportingtag:{},
      updatetag: false,
      button_id: "",
      cus_add_address: {
        cus_id: "",
        cus_addr_line_1: "",
        cus_addr_line_2: "",
        cus_state: "",
        cus_city: "",
        cus_country: "",
        cus_pincode: "",
        cus_addr_id: "",
        cus_addr_type: "",
        cus_addr_cat: 1
      },
      customeraddress: [
        {
          cus_addr_id: "",
          addr_line_1: "",
          addr_line_2: "",
          state: "",
          city: "",
          pincode: ""
        }
      ],
      itemfromsalesorder: true,
      cusaddress: {
        cus_addr_id: "",
        is_billing: "",
        is_shipping: "",
        bill_sal_addr_type: 1,
        bill_sal_addr_line_1: "",
        bill_sal_addr_line_2: "",
        bill_sal_state: "",
        bill_sal_city: "",
        bill_sal_pincode: "",
        bill_country: "",
        ship_sal_addr_type: 2,
        ship_sal_addr_line_1: "",
        ship_sal_addr_line_2: "",
        ship_sal_state: "",
        ship_sal_city: "",
        ship_sal_pincode: "",
        ship_country: ""
      },
      unit_discount: 0,
      splitted_tax: [],
      search_value: "Customer Name",
      search_column: "cus_display_name",
      pageredirect: "",
      error_show: false, // to show the error message
      update_price: false, // update input after one bind
      modal_tag_id: {}, // variable for tabg modal
      modal_eqmnt_id: {},
      modal_sales_person_id: {}, // variable for sales person id modal
      modal_pjt_id: {}, // variable for projcet create modal
      old_inv_itm_ids: "",
      item_id: "", // item id for product create modal
      cus_id: "", // wathc api dropdown data
      customers: [], // store the details of selected custoemr
      total_header: "", // amount
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center", // notification design class
      field: this.createFreshEventObject(), // header detail data initialize
      deletedropdownid: "",
      //  item details data
      items: [this.itemFields()],
      customer_details: 0,
      item_reporting_tag: {},
      exchange_rate_details: {
        currency_exchange_rate: 1,
        save_exchange_rate: 0,
        recalc: 0
      },
      old_cus_id: "",
      old_currency_code: "",
      changed_currency: true,
      old_exchange_rate: 1,
      updatecredit: 0,
      salespersondelete: false,
      salesprojectdelete: false,
      excemptmodal: false,
      modal_exempt_reason: "",
      exempt_index: ""
    };
  },

  methods: {
    redirectPage(){
       this.$router.push({
        name:'AmcContractView',
        params:{
            id:this.$route.params.id
        }
      })
     },
    callexemptmodal(val) {
      this.$nextTick(() => {
        this.$root.$emit("bv::show::modal", "addexempt");
        this.modal_exempt_reason = val;
      });
    },
    getMultipleAddedRefExempt(ev) {
      if (ev.close) {
        this.excemptmodal = false;
        return;
      }

      this.items[this.exempt_index].exempt_reason_id = "";
      this.items[this.exempt_index].exempt_reason_id = this.update_exempt_id;
    },
    changedReverseCharge(ev) {
      if (ev == 1) {
        for (var i = 0; i < this.items.length; i++) {
          this.items[i].tax_id = "";
          this.items[i].exempt_reason_id = "";
        }
      }
    },
    async removepricelist(ev) {
      // remove pricing header id if sames as ev
      if (this.field.pricing_hdr_id) {
        var hdr = ev[ev.indexOf(this.field.pricing_hdr_id)];
        this.contactremoved = await (this.field.pricing_hdr_id == hdr
          ? true
          : false);

        if (this.field.pricing_hdr_id == hdr) {
          this.field.pricing_hdr_id = await null;
        }
      } else {
        //  check ev present in pricingheader
        for (var i = 0; i < this.items.length; i++) {
          var itm = ev[ev.indexOf(this.items[i].pricing_hdr_id)];
          if (this.items[i].pricing_hdr_id == itm) {
            this.items[i].pricing_hdr_id = null;
            this.items[i].pricing_currency = null;
          }
        }
      }
    },
    alertpricelist() {
      // before replacing price list to all the itms show alert
      if (this.update_price == true) {
        if (
          this.items.length > 1 ||
          (this.items.length == 1 && this.items[0].pdt_id)
        ) {
          this.globaltitle = "Apply New Price list";
          //  content will get differ for removeing contact and during changing the price lisl
          this.globalcontent =
            "You have selected a new Pricelist. We’ll apply the new product price.";
          if (this.field.pricing_hdr_id == null) {
            this.globalcontent =
              "You have removed the Pricelist. We’ll apply the original product price for all products.";
          }
          if (this.contactremoved == true) {
            this.globalcontent =
              "We will update the pricelist applied to the products in this transaction as you've changed the Contact";
          }
          this.globalcallsuccess = true;
          this.$root.$emit("bv::show::modal", "alertmodal");
        } else {
          //  if line item not present directly call fucntion
          this.alertsuccessglobalmodal();
        }
      }
    },
    customerCreditLimt(scope) {
      if (
        this.cus_settings_details.cus_credit_limit &&
        this.cus_settings_details.cus_credit_limit.enable == 1 &&
        this.updatecredit != 1
      ) {
        this.show_credit_modal = false;
        this.cus_credit_error = false;
        this.submitForm();
      } else if (this.updatecredit == 1) {
        this.$validator.validateAll(scope).then(result => {
          if (result) {
            this.submitted = true;
            this.$store
              .dispatch("customer/updateCreditLimit", {
                cus_id: this.field.cus_id,
                credit_limit: this.credit_limit
              })
              .then(() => {
                window.Messenger().post({
                  extraClasses:
                    "messenger-fixed messenger-on-top messenger-on-center",
                  message: this.credit_success,
                  type: "success",
                  showCloseButton: true
                });
                this.cus_credit_limit = this.credit_limit;
                this.show_credit_modal = false;
                this.updatecredit = 0;
                this.onSubmit("invoice-form");
                this.submitted = false;
                this.cus_credit_error = false;
              });
          } else {
            this.cus_credit_error = true;
          }
        });
      } else {
        this.show_credit_modal = false;
        this.cus_credit_error = false;
      }
    },
    updateCreditLimit() {
      this.$store
        .dispatch("customer/updateCreditLimit", {
          cus_id: this.field.cus_id,
          credit_limit: this.credit_limit
        })
        .then(() => {
          window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: this.credit_success,
            type: "success",
            showCloseButton: true
          });
          this.cus_credit_limit = this.credit_limit;
          this.show_credit_modal = false;
          this.onSubmit("invoice-form");
        });
    },
    alertsuccessglobalmodal() {
      this.calculateallpricelist(this.field.pricing_hdr_id, "sales");
    },
    calculateallpricelist(ev, type) {
      if (this.update_price == true) {
        this.contactremoved = false;
        //  get all the pdt ids and index to recalculate the price list
        var pdt_ids = [];
        var index = [];
        for (var i = 0; i < this.items.length; i++) {
          //  store the index and pdt ids in separate array
          index.push(i);
          pdt_ids.push(this.items[i].pdt_id);
          this.items[i].pricing_hdr_id = this.items[i].pricing_hdr_id =
            (this.enablepricelist.is_price_list_enabled == 1 &&
              this.enablepricelist.is_item_level_price_list_enabled == 1) ||
            (this.page == "update" && this.list.is_price_id_exist == 1)
              ? ev
              : null;
        }
        //  then call the indicidual price list call
        this.calculatepricelist(pdt_ids, ev, type, index);
      }
    },
    updateslabrate(slab, item, cus_currency) {
      if (this.update_price == true) {
        var update = 0;
        //  check if the sprice list is slab rate
        if (Array.isArray(slab)) {
          slab.map(value => {
            // if the quantity is betweeen the start and end qty
            if (
              value.end_qty >= item.pdt_qty &&
              value.start_qty <= item.pdt_qty
            ) {
              //  if organization currenyc mismatch with the pricing currency
              if (
                item.pricing_currency != null &&
                this.org_details.org_currency != item.pricing_currency
              ) {
                cus_currency = 1;
              }
              update = 1;
              //  calculate the unit price
              item.unit_price = parseFloat(
                parseFloat(value.custom_price) / parseFloat(cus_currency)
              ).toFixed(2);
              return;
            }
          });
          var unit_price = slab[slab.length - 1].custom_price;
          if (update == 0) {
            //  if it is not persent in slab use old unit price
            item.unit_price = parseFloat(
              parseFloat(unit_price) / parseFloat(cus_currency)
            ).toFixed(2);
          }
        }
      }
    },
    calculatepricelist(pdt_ids, pricing_hdr_id, type, index) {
      if (this.update_price == true) {
        // cus currency based on the foreign and intra
        var cus_currency =
          !isNaN(this.field.unit_currency_value) &&
          this.field.is_export == 2 &&
          this.field.unit_currency_value != 0
            ? this.field.unit_currency_value
            : 1;

        this.pricelist(pdt_ids, pricing_hdr_id, type).then(data => {
          //  get the unit price result from the api call and apply it to item
          var heads_up = [];
          for (var i = 0; i < this.items.length; i++) {
            var pricelistdata = data.item_details[this.items[i].pdt_id];
            if (this.items[i].pdt_id && pricelistdata && index.includes(i)) {
              this.items[i].pricing_currency = data.currency_id;
              //  if currency id mismatch then assign the same unit price without any change
              if (
                data.currency_id != null &&
                pricelistdata.no_data == false &&
                this.org_details.org_currency != data.currency_id
              ) {
                cus_currency = 1;
              }
              // assign new var pricing scheme
              this.items[i].pricing_scheme = pricelistdata.pricing_scheme;
              //  if default value applied
              if (
                (pricelistdata.no_data == true &&
                  pricelistdata.pricing_scheme != 2) ||
                (pricelistdata.pricing_scheme == 2 &&
                  pricelistdata.price_slab == null)
              ) {
                var pricing_name = pricelistdata.pricing_name;
                heads_up.push(
                  this.$refs["pdt_name_typeahead_" + i][0].inputValue
                );
              }
              //  if the price list is price slab rate then call slabrate function
              if (
                pricelistdata.pricing_scheme == 2 &&
                pricelistdata.price_slab != null
              ) {
                this.items[i].slab = pricelistdata.price_slab;

                this.updateslabrate(
                  pricelistdata.price_slab,
                  this.items[i],
                  cus_currency
                );
                this.items[i].slab_min_qty = pricelistdata.min_qty;
                this.items[i].slab_max_qty = pricelistdata.max_qty;
                continue;
              }
              //  if it is unit price or mark up or mark down assign the unit price value
              this.items[i].slab = "";
              this.items[i].unit_price = parseFloat(
                parseFloat(pricelistdata.price_list_rate) /
                  parseFloat(cus_currency)
              ).toFixed(2);
            }
          }
          //  if default rate aplied
          if (heads_up.length > 0) {
            if (heads_up.length == 1) {
              this.globalcontent =
                heads_up[0] +
                " is not in the price list " +
                pricing_name +
                ".We've applied the default rate specified for " +
                heads_up[0];
            } else {
              this.globalcontent =
                "Heads up! We've applied the default prices for the products that are not present in the " +
                pricing_name +
                " pricelist.";
            }
            this.globalcallsuccess = false;
            this.$root.$emit("bv::show::modal", "alertmodal");
          }
        });
      }
    },
    // call reporting tag modal
    async callreportingmodal(val) {
      this.singleitemrow = await val;
      var data = {};
      // find reporting tag fields update item values
      for (var i = 0; i < this.reporting_tags.length; i++) {
        if (
          !this.singleitemrow.hasOwnProperty(
            this.reporting_tags[i].tag_column_name
          )
        ) {
          this.singleitemrow[this.reporting_tags[i].tag_column_name] = "";
        }
        data[this.reporting_tags[i].tag_column_name] =(this.reportingtag[this.reporting_tags[i].tag_column_name]!=0&&typeof this.reportingtag[this.reporting_tags[i].tag_column_name]!=undefined)&&(this.singleitemrow[this.reporting_tags[i].tag_column_name]==0||typeof this.singleitemrow[this.reporting_tags[i].tag_column_name]==undefined)?this.reportingtag[this.reporting_tags[i].tag_column_name]:(this.singleitemrow[this.reporting_tags[i].tag_column_name]!=0&&this.singleitemrow[this.reporting_tags[i].tag_column_name]!=''&&typeof this.singleitemrow[this.reporting_tags[i].tag_column_name]!=undefined)?this.singleitemrow[this.reporting_tags[i].tag_column_name]:''
      }
      this.item_reporting_tag = await data;
      await this.$root.$emit("bv::show::modal", "reportingtagmodal");
    },
    //  change the location of all the items to the selected location
    changelocationallitems(val) {
      //  find the create items and change the tax dropdown appropriately
      for (var index = 0; index < this.items.length; index++) {
        this.items[index].warehouse_id = val;
      }
    },
    //Customer details
    async toggleCustomerAdditionalDetails() {
      this.cus_add_address = {
        cus_id: this.field.cus_id,
        cus_addr_line_1: "",
        cus_addr_line_2: "",
        cus_state: "",
        cus_city: "",
        cus_country: "",
        cus_pincode: "",
        cus_addr_type:
          this.cusaddress.is_billing == 1 && this.cusaddress.is_shipping == 0
            ? 2
            : this.cusaddress.is_billing == 0 &&
              this.cusaddress.is_shipping == 1
            ? 1
            : this.cusaddress.is_billing == 0 &&
              this.cusaddress.is_shipping == 0
            ? 1
            : 3,
        cus_addr_id:
          this.cus_add_address.cus_addr_type == 1
            ? this.cusaddress.cus_bill_addr_id
            : this.cus_add_address.cus_addr_type == 2
            ? this.cusaddress.cus_ship_addr_id
            : "",
        cus_addr_cat: 1
      };
      await EventBus.$emit("toggleCustomerAdditionalDetails");
    },
    customerAddAddress(ev) {
      this.customeraddress = ev;
      this.field["address"] = {
        bill_sal_addr_type: 1,
        cus_bill_addr_id: this.customer_addr[0].cus_addr_id,
        cus_ship_addr_id: this.customer_addr[1].cus_addr_id,
        is_billing: this.customer_addr[0].is_billing,
        bill_sal_addr_line_1: this.customer_addr[0].addr_line_1,
        bill_sal_addr_line_2: this.customer_addr[0].addr_line_2,
        bill_sal_state: this.customer_addr[0].state,
        bill_sal_city: this.customer_addr[0].city,
        bill_sal_pincode: this.customer_addr[0].pincode,
        bill_sal_country: this.customer_addr[0].country,
        ship_sal_addr_type: 2,
        is_shipping: this.customer_addr[1].is_shipping,
        ship_sal_addr_line_1: this.customer_addr[1].addr_line_1,
        ship_sal_addr_line_2: this.customer_addr[1].addr_line_2,
        ship_sal_state: this.customer_addr[1].state,
        ship_sal_city: this.customer_addr[1].city,
        ship_sal_pincode: this.customer_addr[1].pincode,
        ship_sal_country: this.customer_addr[1].country
      };
      this.cusaddress = JSON.parse(JSON.stringify(this.field["address"]));
    },

    updatedatafromsalesorder() {
      Object.assign(this.items, this.list.order_item_details);

      this.itemfromsalesorder = false;
    },
    //  to show and update customer address detaila with validation control
    customerAddress(ev) {
      this.field.address = JSON.parse(JSON.stringify(ev));
    },
    async toggleCustomerAddressDetails() {
      await EventBus.$emit("toggleCustomerAddressDetails");
    },
    selectShippingDate(val) {
      //  up0date the due date in proper date formeate
      this.field.shipping_bill_date =
        val == "" || typeof val == "undefined" || val == null
          ? ""
          : this.formatDate(val);
    },
    //Customer details
    async toggleCustomerDetails() {
      if (this.customer_details == 0) {
        await this.$store
          .dispatch("customer/fetchViewList", this.field.cus_id)
          .then(() => {
            this.customer_details = 1;
          });
        await EventBus.$emit("toggleCustomerDetails");
      } else {
        await EventBus.$emit("toggleCustomerDetails");
      }
    },

    //  call delete dropdown modal
    calldeletemodal(val) {
      this.$nextTick(() => {
        this.$root.$emit("bv::show::modal", "invoice-dropdown-delete");
        this.deletedropdownid = val;
      });
    },
    getDropdownDelete(ev) {
      if (ev == 200) {
        if (this.salespersondelete) {
          this.field.sales_person_id =
            this.field.sales_person_id == this.deletedropdownid
              ? ""
              : this.field.sales_person_id;
        } else if (this.salesprojectdelete) {
          this.field.pjt_id = "";
        } else if (this.field.inv_tags != []) {
          var index = this.field.inv_tags.indexOf(this.deletedropdownid);
          if (index != -1) {
            this.field.inv_tags.splice(index, 1);
          }
        }
        this.deletedropdownid = "";
        this.invoicetagdelete = false;
        this.salespersondelete = false;
        this.salesprojectdelete = false;
      }
      if (ev) {
        this.deletedropdownid = "";
        this.invoicetagdelete = false;
        this.salespersondelete = false;
        this.salesprojectdelete = false;
        return;
      }
    },
    //  add the newly added fields

    getAddedRef() {
      this.field.sales_person_id = "";
      this.field.sales_person_id = this.updatedtag_id;
    },
    getAddedRefproject() {
      this.field.pjt_id = "";
      this.field.pjt_id = this.updatedtag_id;
    },
    //  add the newly added fields
    getMultipleAddedRef(ev) {
      if (ev.close) {
        this.invoicetagmodal = false;
        return;
      }
      var value = this.updatedtag_id;
      if (this.updatetag != true) {
        this.field.inv_tags.push(value);
      }
    },
    //  update code details
    getCodeValue(ev) {
      this.field.code_id = ev.code_id;
      this.field.suffix = ev.suffix;
      this.field.prefix = ev.prefix;
      this.field.inv_no = ev.prefix + ev.suffix;
    },
    paddingZeros(string, len, leading) {
      var pad = string.toString();
      while (pad.length < len) {
        pad = leading + pad;
      }
      return pad;
    },
    //  for rounding off total maount modal
    roundOff(field, digits) {
      var digit = parseInt(digits);
      if (!(this.field[field] === "")) {
        this.field[field] =
          typeof this.field[field] != undefined && !isNaN(this.field[field])
            ? parseFloat(parseFloat(this.field[field]).toFixed(digit))
            : parseFloat(parseFloat(0).toFixed(digit));
      }
    },
    roundOffItem(index, field, digits) {
      var digit = parseInt(digits);
      if (!(this.items[index][field] === "")) {
        this.items[index][field] =
          typeof this.items[index][field] != undefined &&
          !isNaN(this.items[index][field])
            ? parseFloat(parseFloat(this.items[index][field]).toFixed(digit))
            : parseFloat(parseFloat(0).toFixed(digit));
      }
      if (field == "pdt_qty" && this.items[index].pricing_hdr_id) {
        // check if pricing scheme present directly send to slab rate else do api again
        if (this.items[index].pricing_scheme == 2) {
          this.updateslabrate(
            this.items[index].slab,
            this.items[index],
            this.field.unit_currency_value
          );
        } else if (!this.items[index].pricing_scheme) {
          //  if pricing scheme not present check again for slab
          this.calculatepricelist(
            [this.items[index].pdt_id],
            this.items[index].pricing_hdr_id,
            "sales",
            [index]
          );
        }
      }
    },
    // call tag nodal
    calltagmodal(val) {
      this.$nextTick(() => {
        this.$root.$emit("bv::show::modal", "addTag");
        this.modal_tag_id = val;
      });
    },
    //  show location detail popup
    async callsingleitemrowmodal(val) {
      this.singleitemrow = await val;
      await this.$root.$emit("bv::show::modal", "locationdetails");
    },
    //  call sales person modal
    callsalespersonmodal(val) {
      this.$root.$emit("bv::show::modal", "addSalesPerson");
      this.modal_sales_person_id = val;
    },
    //  call project modal
    callprojectmodal(val) {
      this.$root.$emit("bv::show::modal", "addProject");
      this.modal_pjt_id = val;
    },
    //  get the product details on search
    productlist(event, index) {
      if (event != "") {
        store
          .dispatch(
            "general/fetchProductData",
            JSON.stringify({ field: event, pdt_type: "sales" })
          )
          .then(() => {
            this.items[index].products = this.product_filter_list;
          });
      }
    },
    //  get the customer created in modal and selected in dropdown
    getCustomerValue(event) {
      $("#customer_search input").removeClass("mask");
      $("#customer_search .input-group .remover").remove();
      this.field.cus_id = event.id;
      this.$refs.cus_name_typeahead.inputValue = event.cus_name;
     this.reportingtag=event.reportingtag;
      //  pass the details to place of supply modal
      this.checkpos({
        value: event.id,
        pos: event.pos,
        tax_exempt: event.tax_exempt,
        payment_terms: event.cus_pymnt_term,
        currency: event.cus_currency,
        buyer_gst_no: event.cus_gst_no,
        buyer_gst_type: event.cus_gst_type,
        credit_limit: event.credit_limit,
        pricing_hdr_id: event.pricing_hdr_id
      });
    },
    //  get the product created in modal and selected in dropdown
    getProductValue(event) {
      var index = event[0].index;
      var values = event[0];
      var data = {
        value: values.value,
        label: values.label,
        pdt_sal_price: values.pdt_sal_price,
        pdt_tax_id: values.pdt_tax_id,
        exempt_reason_id: values.exempt_reason_id,
        pdt_inter_tax_id: values.pdt_inter_tax_id,
        pdt_hsn: values.pdt_hsn,
        unit_name: values.unit_name,
        pdt_desc: values.pdt_desc,
        pdt_state: values.pdt_state,
        pdt_state_id: values.pdt_state_id,
        pdt_tax_type: values.pdt_tax_type,
        pdt_incl_intra_price: values.pdt_incl_intra_price,
        pdt_incl_inter_price: values.pdt_incl_inter_price,
        is_inventory: values.is_inventory,
        pdt_cat: values.pdt_cat
      };
      // fetch reportin tag field and values append to data
      for (var i = 0; i < this.reporting_tags.length; i++) {
        if (!values.hasOwnProperty(this.reporting_tags[i].tag_column_name)) {
          data[this.reporting_tags[i].tag_column_name] = "";
        }
        data[this.reporting_tags[i].tag_column_name] =
          typeof values[this.reporting_tags[i].tag_column_name] != undefined
            ? values[this.reporting_tags[i].tag_column_name]
            : "";
      }
      //  pass the details to sales rprice modal
      this.checkSalePrice(data, index);
    },
    //  find gst tax applicable or igst tax applicable
    changetax(event) {
      if (this.update_price == true) {
        //  check the place of supply of customer
        var cus_state =
          typeof this.field.place_of_supply != "undefined" &&
          this.field.place_of_supply != null
            ? event
            : 0; // no pos selected assign as zero
        //  if pos not zero enter into conditaion

        //  find the create items and change the tax dropdown appropriately
        for (var index = 0; index < this.items.length; index++) {
          if (cus_state != 0) {
            var pdt_id =
              typeof this.items[index].pdt_id != "undefined" &&
              this.items[index].pdt_id != null
                ? this.items[index].productDetails
                : null;
            if (pdt_id != null) {
              //  if customer state = organizaiton state then gst applcible and vice versa
              var tax_detail =
                cus_state == this.org_details.org_state
                  ? pdt_id.pdt_tax_id
                  : pdt_id.pdt_inter_tax_id;

              if (pdt_id.pdt_tax_type == 1) {
                this.items[index].unit_price =
                  cus_state == this.org_details.org_state
                    ? pdt_id.pdt_incl_intra_price
                    : pdt_id.pdt_incl_inter_price;
              }
              if (this.field.tax_exempt == 1) {
                this.items[index].tax_id =
                  cus_state == this.org_details.org_state ? 8 : 17;
              } else {
                this.items[index].tax_id =
                  typeof this.field.cus_id == "undefined" ||
                  this.field.cus_id == ""
                    ? 8
                    : tax_detail;
              }
            }
          } else {
            this.items[index].tax_id = "";
          }
        }
      }
    },
    //  check the place of supply equas organjzation state
    checkstate() {
      var cus_state =
        typeof this.field.place_of_supply != "undefined" &&
        this.field.place_of_supply != null
          ? this.field.place_of_supply
          : 0;
      return cus_state == this.org_details.org_state;
    },
    //  change the due date based on the payment in the customer master data and selected invoice date
    selectDate(val) {
      //  if the payment term in selected customer not empty enter into condition

      if (
        this.getPresentValue(
          this.pymnt_trm_list,
          "pymnt_terms_id",
          this.pymnt_terms,
          "days"
        ) != "" &&
        val != ""
      ) {
        //  if payment term is 1= due end of the month
        if (this.pymnt_terms == 5) {
          this.field.inv_due_date = this.formatDate(moment(val).endOf("month"));
        } else if (this.pymnt_terms == 6) {
          var date = moment(val).add(1, "months"); // due 2 months
          this.field.inv_due_date = this.formatDate(
            moment(date).endOf("month")
          );
        } else {
          // due 45 or 60 or 15base on the payment term dropdwon
          this.field.inv_due_date = this.formatDate(
            moment(val).add(
              "days",
              parseInt(
                this.getPresentValue(
                  this.pymnt_trm_list,
                  "pymnt_terms_id",
                  this.pymnt_terms,
                  "days"
                )
              )
            )
          );
        }
      }

      this.field.sales_date =
        val == "" || typeof val == "undefined" || val == null
          ? ""
          : this.formatDate(val);
      this.getExchangeRateValue(1);
    },
    selectDueDate(val) {
      //  up0date the due date in proper date formeate
      this.field.inv_due_date =
        val == "" || typeof val == "undefined" || val == null
          ? ""
          : this.formatDate(val);
    },
    //  calculate subtotal modal
    computeSubTotal: function(item) {
      if (item.pdt_id != "" && this.update_price == true) {
        //  check pdt qty
        var pdt_qty =
          !isNaN(item.pdt_qty) && item.pdt_qty != ""
            ? parseFloat(item.pdt_qty)
            : 0;
        //  check the unitprice
        var unit_price =
          !isNaN(item.unit_price) && item.unit_price != ""
            ? parseFloat(item.unit_price)
            : 0;
        //  check the selected tax percent
        var tax_percent =
          item.tax_id && this.tax_list[item.tax_id]
            ? parseFloat(this.tax_list[item.tax_id]["tax_percent"])
            : 0;
        item.tax_percent = tax_percent; //update tax percent value
        var tax_id = !isNaN(item.tax_id) && item.tax_id != 0 ? item.tax_id : 0;

        //  calculate price with qty
        var actual_pdt_price_with_qty =
          parseFloat(unit_price) * parseFloat(pdt_qty);
        var formal_pdt_price_with_qty = 0;
        if (this.field.tax_type_id == 1) {
          //  get unit price and qty(multiple)

          // find the amount before tax
          formal_pdt_price_with_qty =
            parseFloat(actual_pdt_price_with_qty) -
            (parseFloat(actual_pdt_price_with_qty) /
              (1 + parseFloat(tax_percent) / 100)) *
              (parseFloat(tax_percent) / 100);
        } else {
          formal_pdt_price_with_qty =
            parseFloat(unit_price) * parseFloat(pdt_qty);
        }

        //  check the discount amount in either percent or amount
        var discount_amount = 0;
        var incl_discount_amount = 0;
        if (this.field.discount_cat == 1) {
          if (item.is_percent == 0) {
            discount_amount =
              !isNaN(item.discount_amount) && item.discount_amount != ""
                ? parseFloat(item.discount_amount)
                : 0;
            incl_discount_amount = discount_amount;
          } else {
            discount_amount =
              !isNaN(item.discount_amount) && item.discount_amount != ""
                ? (formal_pdt_price_with_qty * item.discount_amount) / 100
                : 0;
            var tax_incl_discount_amount =
              this.field.tax_type_id == 1
                ? formal_pdt_price_with_qty
                : actual_pdt_price_with_qty;
            incl_discount_amount =
              !isNaN(item.discount_amount) && item.discount_amount != ""
                ? (tax_incl_discount_amount * item.discount_amount) / 100
                : 0;
          }
        } else if (
          this.field.discount_cat == 2 ||
          this.field.discount_cat == 3
        ) {
          discount_amount =
            parseFloat(formal_pdt_price_with_qty) *
            parseFloat(this.unit_discount);
          incl_discount_amount = 0;
        }

        // <!-----------------------------------discount before tax and line item discount before tax ------------>
        //  calcualte the subtotal using above parameters
        var subtotal_with_discount =
          this.field.discount_cat == 3
            ? parseFloat(formal_pdt_price_with_qty)
            : parseFloat(formal_pdt_price_with_qty) -
              parseFloat(discount_amount);
        subtotal_with_discount = subtotal_with_discount.toFixed(2);
        var tax_value = 0;
        var tax_ids = [];
        if (this.tax_list[tax_id] && this.org_details.gst_type == 1) {
          tax_ids = this.tax_list[tax_id].tax_ids
            ? this.tax_list[tax_id].tax_ids.split(",")
            : "";
        }

        if (
          tax_ids != "" &&
          tax_ids != null &&
          typeof tax_ids != "undefined" &&
          this.org_details.gst_type == 1
        ) {
          for (var i = 0; i < tax_ids.length; i++) {
            tax_value += parseFloat(
              parseFloat(
                (subtotal_with_discount *
                  this.tax_main[tax_ids[i]].tax_percent) /
                  100
              )
            );
          }
        }

        item.tax_value = pdt_qty == 0 ? 0 : parseFloat(tax_value).toFixed(2);

        // <!-----------------------------------discount after tax and line item discount after tax ------------>

        var subtotal = 0;

        if (this.field.tax_type_id == 1) {
          subtotal =
            parseFloat(formal_pdt_price_with_qty) -
            parseFloat(incl_discount_amount);
          subtotal =
            (parseFloat(subtotal) * parseFloat(tax_percent)) / 100 +
            parseFloat(subtotal);
        } else {
          subtotal =
            parseFloat(actual_pdt_price_with_qty) -
            parseFloat(incl_discount_amount);
        }
        item.item_pdt_price_with_qty = parseFloat(
          formal_pdt_price_with_qty
        ).toFixed(2);
        item.item_tax_amount = parseFloat(item.tax_value).toFixed(2);
        item.item_discount_amount = discount_amount;
        item.item_without_tax =
          this.field.discount_cat != 3
            ? parseFloat(formal_pdt_price_with_qty) - discount_amount
            : parseFloat(formal_pdt_price_with_qty);
        discount_amount = this.field.discount_cat != 3 ? 0 : discount_amount;
        if (this.field.tax_type_id == 1) {
          item.item_with_tax =
            (parseFloat(item.item_without_tax) * parseFloat(tax_percent)) /
              100 +
            parseFloat(item.item_without_tax) -
            discount_amount;
        } else {
          item.item_with_tax =
            parseFloat(item.item_without_tax) +
            parseFloat(item.tax_value) -
            discount_amount;
        }
        subtotal = !isNaN(subtotal) && subtotal != "" ? subtotal : 0;

        return pdt_qty == 0 ? 0 : subtotal.toFixed(2);
      }
    },
    //change exchange rate
    async changeExchangeRate() {
      await this.recalcUnitPrice(this.field.unit_currency_value);
      this.old_exchange_rate = this.field.unit_currency_value;
      this.field.unit_currency_value =
        parseFloat(this.field.unit_currency_value) <= 0 ||
        this.field.unit_currency_value == ""
          ? 1
          : this.field.unit_currency_value;
    },
    // get exchange rate value with transcation date
    getExchangeRateValue(date_change) {
      this.$store
        .dispatch("customer/getCurrencyRate", {
          id: this.field.cus_id,
          currency_id: this.field.cus_currency,
          date: this.field.sales_date
        })
        .then(() => {
          this.field.unit_currency_value =
            this.currency_details.currency_exchange_rate != "" &&
            this.currency_details.currency_exchange_rate > 0
              ? this.currency_details.currency_exchange_rate
              : this.currency_details.currency_code == this.orgCurrency
              ? 1
              : this.old_exchange_rate;
          this.field.currency_code = this.currency_details.currency_code;
          if (
            this.old_cus_id != this.field.cus_id &&
            this.old_currency_code != this.field.currency_code
          ) {
            this.changed_currency = true;
            this.recalcUnitPrice(this.field.unit_currency_value);
            this.old_exchange_rate = this.field.unit_currency_value;
            if (
              this.field.currency_code != this.orgCurrency &&
              this.old_currency_code != ""
            ) {
              if (this.items.some(x => x.pdt_id != "") && date_change != 1) {
                this.$root.$emit("bv::show::modal", "cus_change_exchange_rate");
              }
            }
          } else {
            this.changed_currency = this.page == "update" ? false : true;
          }
        });
    },
    // currency exchange rate dropdown form submit
    exchangeRateSubmit() {
      if (this.exchange_rate_details.save_exchange_rate == 1) {
        var data = {
          currency_id: this.field.cus_currency,
          date: this.field.sales_date,
          value: this.exchange_rate_details.currency_exchange_rate,
          code: this.field.currency_code
        };
        data = JSON.stringify(data);
        this.$store.dispatch("currency/addExchangeRate", data).then(() => {
          this.submitted = false;
          if (this.exchange_rate_type == "success") {
            this.error_msg = false;
            //to show the alert message for success or error after api call
            window.Messenger().post({
              extraClasses:
                "messenger-fixed messenger-on-top messenger-on-center",
              message: this.exchange_rate_message,
              type: this.exchange_rate_type,
              showCloseButton: true
            });
          } else {
            this.error_msg = true;
          }
        });
      }
      if (
        this.exchange_rate_details.recalc == 1 &&
        this.field.unit_currency_value !=
          this.exchange_rate_details.currency_exchange_rate
      ) {
        this.recalcUnitPrice(this.exchange_rate_details.currency_exchange_rate);
      }
      this.old_exchange_rate = this.exchange_rate_details.currency_exchange_rate;
      this.field.unit_currency_value = this.exchange_rate_details.currency_exchange_rate;
      // hide dropdown exchange_rate_dropdown
      this.$refs.exchange_rate_dropdown.hide(true);
    },
    // recalculate unit price of products with exchange rate
    recalcUnitPrice(currency_rate) {
      var temp = this;
      this.items.map(function(value) {
        if (value.pdt_id != "") {
          value.unit_price = parseFloat(
            (parseFloat(temp.old_exchange_rate) *
              parseFloat(value.unit_price)) /
              parseFloat(currency_rate)
          ).toFixed(2);
        }
      });
    },
    submitForm() {
      this.non_tax = this.items.filter(function(nontax) {
        return (
          nontax.tax_id == 19 ||
          nontax.tax_id == 20 ||
          nontax.tax_id == 8 ||
          nontax.tax_id == 17
        );
      });
      if (
        this.non_tax.length == this.items.length &&
        this.bill_of_supply &&
        this.type == "invoice" &&
        this.page == "create" &&
        this.button_id != 3
      ) {
        this.$root.$emit("bv::show::modal", "bill_of_supply");
      } else {
        this.field.inv_status = this.inv_status;
        //  send the json data
        var data = JSON.stringify({
          header_details: this.field,
          item_details: this.items,
          old_inv_itm_ids: this.old_inv_itm_ids
        });
        this.$emit("onSubmit", {
          data: data,
          pageredirect: this.pageredirect
        });
      }
    },
    onSubmit(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          if (
            this.cus_settings_details.cus_credit_limit &&
            this.cus_settings_details.cus_credit_limit.enable == 1 &&
            parseFloat(this.cus_credit_limit) > 0 &&
            parseFloat(
              parseFloat(this.cus_credit_limit) +
                parseFloat(this.unused_credits)
            ) <
              parseFloat(
                parseFloat(this.total_due_amt) +
                  parseFloat(this.total.total_with_adjustments) -
                  (this.field.inv_status == 1
                    ? 0
                    : parseFloat(this.inv_grand_total))
              )
          ) {
            this.show_credit_modal = true;
          } else {
            this.submitForm();
          }
        } else {
          // Scroll to error message show
          var content = $(".container-fluid");
          content[0].scrollIntoView(false);
          this.error_show = true; // validate the form if fail
        }
      });
      return false;
    },
    createFreshEventObject() {
      // empty details for header
      return {
        pricing_hdr_id: null,
        pricing_scheme: null,
        is_amc: 1,
        cus_inv_notes: "",
        amc_hdr_id: "",
        sal_id: "",
        cus_currency: "",
        currency_code: this.orgCurrency,
        is_export: 1,
        country_of_supply: "",
        export_type: "",
        shipping_bill_number: "",
        shipping_bill_date: "",
        shipping_port_code: "",
        unit_currency_value: 1,
        inv_no: "",
        warehouse_id: "",
        tax_type_id: 2,
        is_discount_percent: 0,
        discount_amount: "0.00",
        discount_cat: 1,
        adjustment_name: "Adjustment",
        eqmnt_id: "",
        inv_status: "1",
        adjustments: 0,
        sales_person_id: "",
        cus_id: "",
        place_of_supply: "",
        inv_tags: [],
        sales_date: this.formatDate(new Date()),
        ref_no: "",
        type: "invoice",
        code_id: "",
        prefix: "",
        suffix: "",
        internal_notes: "",
        inv_notes: "",
        tax_exempt: "",
        pjt_id: "",
        inv_due_date: "",
        pymnt_terms: "",
        buyer_gst_no: "",
        buyer_gst_type: "",
        seller_gst_no: "",
        seller_gst_type: "",
        order_no: "",
        is_shipping_charge: 0,
        shipping_amount: "0",
        is_adjustment: 0,
        address: {
          bill_sal_addr_type: 1,
          bill_sal_addr_line_1: "",
          bill_sal_addr_line_2: "",
          bill_sal_state: "",
          bill_sal_city: "",
          bill_sal_pincode: "",
          bill_country: "",
          ship_sal_addr_type: 2,
          ship_sal_addr_line_1: "",
          ship_sal_addr_line_2: "",
          ship_sal_state: "",
          ship_sal_city: "",
          ship_sal_pincode: "",
          ship_country: ""
        }
      };
    },
    // remove row option
    removeRow(index) {
      var i;
      if (typeof this.items[parseInt(index) + 1] != "undefined") {
        for (i = index; i < this.items.length - 1; i++) {
          var pdt_name = "pdt_name_typeahead_" + i;
          // this.$refs[pdt_name][0].inputValue = this.items[i + 1].pdt_detail_id;
          this.$refs[pdt_name][0].inputValue = this.items[
            i + 1
          ].productDetails.label;
          if (this.items[i + 1].pdt_detail_id == "") {
            $("#vuebootsearcher" + i + " input").removeClass("mask");
            $("#vuebootsearcher" + i + " .input-group .remover").remove();
          }
        }
      }
      if (this.items.length > 1) {
        this.items.splice(index, 1);
      }
    },
    //  item details
    itemFields() {
      return {
        pricing_hdr_id: null,
        pricing_scheme: null,
        pdt_id: "",
        cnvt_crdt_rtn_qty: 0,
        pdt_detail_id: "",
        productDetails: {},
        inv_itm_id: "",
        sal_itm_id: "",
        pdt_hsn: "",
        unit_name: "",
        pdt_state_id: "",
        pdt_desc: "",
        products: [],
        is_inventory: 0,
        warehouse_id: 1,
        tax_ids: "",
        is_percent: 1,
        cnvt_crdt_qty: 0,
        locationdetails: {},
        unit_price: 0,
        tax_percent: 0,
        tax_value: 0,
        pdt_qty: 1,
        tax_id: 0,
        tax_rates: [],
        discount_amount: 0,
        subtotal: "0",
        item_pdt_price_with_qty: "0",
        item_tax_amount: "0",
        item_discount_amount: "0",
        item_without_tax: "0",
        item_with_tax: "0"
      };
    },
    // add new row option
    addNewRow() {
      this.items.push(this.itemFields());
    },
    //  remove the design of removed product
    removeproduct(e, index) {
      if (e.target.matches(".remover")) {
        $("#vuebootsearcher" + index + " input").removeClass("mask");
        $("#vuebootsearcher" + index + " .input-group .remover").remove();
        var pdt_name = "pdt_name_typeahead_" + index;
        this.$refs[pdt_name][0].inputValue = "";
        this.items[index].pdt_id = "";
        this.items[index].pdt_detail_id = "";
        this.items[index].pdt_desc = "";
        this.items[index].pdt_hsn = "";
        this.items[index].unit_name = "";
        this.items[index].unit_price = 0;
        this.items[index].tax_percent = 0;
        this.items[index].tax_value = "";
        this.items[index].tax_id = "";
        this.items[index].tax_ids = "";
        this.items[index].discount_amount = 0;
        this.items[index].is_inventory = 0;
        this.items[index].warehouse_id = this.field.warehouse_id;
          for (var i = 0; i < this.reporting_tags.length; i++) {
        this.items[index][this.reporting_tags[i].tag_column_name] = "";    
      }
        this.items[index].pricing_hdr_id = this.items[index].pricing_hdr_id =
          (this.enablepricelist.is_price_list_enabled == 1 &&
            this.enablepricelist.is_item_level_price_list_enabled == 1) ||
          (this.page == "update" && this.list.is_price_id_exist == 1)
            ? this.field.pricing_hdr_id
            : null;
        this.items[index].pdt_qty = 1;
        this.items[index].pdt_state = "";
        this.items[index].pdt_state_id = "";
      }
    },
    locationdetails(index, id) {
      this.$store
        .dispatch(
          "salesorder/locationdetails",
          JSON.stringify({
            id: id
          })
        )
        .then(result => {
          this.items[index].locationdetails = result.stock_details;
        });
    },
    checkSalePrice(event, index) {
      $("#vuebootsearcher" + index + " input").addClass("mask");
      $("#vuebootsearcher" + index + " .input-group").append(
        "<span class='la la-close p-2 mt-1 remover cursor_pointer bg-white'></span>"
      );
      if (this.update_price == true) {
        if (event.value != null) {
          var pdt_name = "pdt_name_typeahead_" + index;
          this.$refs[pdt_name][0].inputValue = event.label;
          this.items[index].pdt_id = event.value; // assing the selcted product id to pdt_id modal
          this.items[index].unit_price = event.pdt_sal_price; // get unit price of the selected product
          this.items[index].pdt_hsn = event.pdt_hsn; // get the pdt hsn of the selected product
          this.items[index].unit_name = event.unit_name; // get the pdt hsn of the selected product
          this.items[index].pdt_desc = event.pdt_desc; // get the pdt hsn of the selected product
          this.items[index].pdt_state = event.pdt_state; // get the pdt hsn of the selected product
          this.items[index].productDetails = event;
          this.items[index].is_inventory = event.is_inventory;
          this.items[index].warehouse_id = this.field.warehouse_id;
          this.items[index].pdt_cat = event.pdt_cat;
          this.items[index].exempt_reason_id = event.exempt_reason_id;
          // calculate price list if exists
          if (this.field.pricing_hdr_id) {
            this.calculatepricelist(
              [this.items[index].pdt_id],
              this.items[index].pricing_hdr_id,
              "sales",
              [index]
            );
          }

          //  check place of supply and tax for selected product to assign the tax
          var cus_state =
            typeof this.field.place_of_supply != "undefined" &&
            this.field.place_of_supply != null
              ? this.field.place_of_supply
              : 0;
          var cus_currency =
            !isNaN(this.field.unit_currency_value) &&
            this.field.unit_currency_value != 0
              ? this.field.unit_currency_value
              : 1;
          // fetch reporting tag fields and values
          for (var i = 0; i < this.reporting_tags.length; i++) {
            if (!event.hasOwnProperty(this.reporting_tags[i].tag_column_name)) {
              this.items[index][this.reporting_tags[i].tag_column_name] = "";
            }
            this.items[index][this.reporting_tags[i].tag_column_name] =
              typeof event[this.reporting_tags[i].tag_column_name] != undefined
                ? event[this.reporting_tags[i].tag_column_name]
                : "";
          }
          if (event.pdt_tax_type == 1) {
            this.items[index].unit_price =
              cus_state == this.org_details.org_state
                ? event.pdt_incl_intra_price
                : event.pdt_incl_inter_price;
          } else {
            this.items[index].unit_price = event.pdt_sal_price;
          }

          if (this.field.is_export == 2) {
            this.items[index].unit_price = parseFloat(
              parseFloat(this.items[index].unit_price) /
                parseFloat(cus_currency)
            ).toFixed(2);
          }

          var tax_detail =
            cus_state == this.org_details.org_state
              ? event.pdt_tax_id
              : event.pdt_inter_tax_id;
          if (this.field.tax_exempt == 1) {
            this.items[index].tax_id =
              cus_state == this.org_details.org_state ? 8 : 17;
          } else {
            this.items[index].tax_id =
              typeof this.field.cus_id == "undefined" || this.field.cus_id == ""
                ? 8
                : tax_detail;
          }
          this.locationdetails(index, event.value);
        }
      }
    },

    //  remove the design of removed customer
    removecustomer(e) {
      if (e.target.matches(".remover")) {
        this.customer_details = 0;
        $("#customer_search input").removeClass("mask");
        $("#customer_search .input-group .remover").remove();
        this.$refs.cus_name_typeahead.inputValue = "";
        this.old_cus_id = this.field.cus_id;
        this.old_currency_code = this.field.currency_code;
        this.old_exchange_rate = this.field.unit_currency_value;
        this.field.cus_id = "";
        this.field.cus_currency = "";
        this.field.place_of_supply = "";
        this.field.pricing_hdr_id = null;
        this.field.buyer_gst_type = "";
        this.cus_credit_limit = 0;
        this.total_due_amt = 0;
        this.unused_credits = 0;
         for (var i = 0; i < this.reporting_tags.length; i++) {
        this.reportingtag[this.reporting_tags[i].tag_column_name]= "";    
      }
      }
    },
    getIndexValue(arr, prop, val) {
      var hasMatch = "";
      for (var i = 0; i < arr.length; i++) {
        if (arr[i][0][prop] == val) {
          hasMatch = i;

          break;
        }
      }
      return hasMatch;
    },
    getPresentValue(arr, prop, val, field) {
      var hasMatch = "";
      for (var i = 0; i < arr.length; i++) {
        if (arr[i][prop] == val) {
          hasMatch = arr[i][field];

          break;
        }
      }
      return hasMatch;
    },
    checkpos(event) {
      if (this.update_price == true) {
        if (
          this.getPresentValue(
            this.pymnt_trm_list,
            "pymnt_terms_id",
            event.payment_terms,
            "days"
          ) != "" &&
          this.created_date != ""
        ) {
          //  update due date based on payment term details
          if (event.payment_terms == 5) {
            this.field.inv_due_date = this.formatDate(
              moment(this.created_date).endOf("month")
            );
          } else if (event.payment_terms == 6) {
            var date = moment(this.created_date).add(1, "months");
            this.field.inv_due_date = this.formatDate(
              moment(date).endOf("month")
            );
          } else {
            this.field.inv_due_date = this.formatDate(
              moment(this.created_date).add(
                "days",
                parseInt(
                  this.getPresentValue(
                    this.pymnt_trm_list,
                    "pymnt_terms_id",
                    event.payment_terms,
                    "days"
                  )
                )
              )
            );
          }
        }
        this.pymnt_terms = event.payment_terms;
        this.field.pymnt_terms = event.payment_terms;
        //  design for selected customer inpout field

        $("#customer_search input").addClass("mask");
        $("#customer_search .input-group").append(
          "<span class='la la-close p-2 mt-1 remover cursor_pointer bg-white'></span>"
        );
        this.field.cus_id = event.value; // assgin the selected customer id to cus id modal
        this.field.buyer_gst_no = event.buyer_gst_no; // get the cusotmer gst no
        this.field.buyer_gst_type = event.buyer_gst_type; // get the gst typ0e of selected cusotmer
        // update pricelist
        if (event.pricing_hdr_id) {
          this.contactremoved = true;
          this.field.pricing_hdr_id = event.pricing_hdr_id;
        }
        // enter if pos not empty
        //  check for foreign currency
        if (event.currency != this.$AppDetails.organization.org_currency) {
          this.field.is_export = 2;
        } else {
          this.field.is_export = 1;
          this.field.place_of_supply = event.pos;
        }
        this.field.cus_currency = event.currency;
        this.changetax(this.field.place_of_supply);

        this.field.tax_exempt = event.tax_exempt;
        //  customer state
        this.$store
          .dispatch("customer/getAddress", this.field.cus_id)
          .then(() => {
            // this.field.address.bill_sal_addr_type = 1;
            this.field["address"] = {
              bill_sal_addr_type: 1,
              cus_bill_addr_id: this.address[0].cus_addr_id,
              cus_ship_addr_id: this.address[1].cus_addr_id,
              is_billing: this.address[0].is_billing,
              is_shipping: this.address[1].is_shipping,
              bill_sal_addr_line_1: this.address[0].addr_line_1,
              bill_sal_addr_line_2: this.address[0].addr_line_2,
              bill_sal_state: this.address[0].state,
              bill_sal_city: this.address[0].city,
              bill_sal_pincode: this.address[0].pincode,
              bill_sal_country: this.address[0].country,
              ship_sal_addr_type: 2,
              ship_sal_addr_line_1: this.address[1].addr_line_1,
              ship_sal_addr_line_2: this.address[1].addr_line_2,
              ship_sal_state: this.address[1].state,
              ship_sal_city: this.address[1].city,
              ship_sal_pincode: this.address[1].pincode,
              ship_sal_country: this.address[1].country
            };
            this.cusaddress = JSON.parse(JSON.stringify(this.field["address"]));
            this.customeraddress = this.address;
          });
      }
    },

    updateFields() {
      this.field = this.list.header_details; // assigning header value to the fiels datas
      this.field.enablepricelist = this.enablepricelist;
      this.field.inv_desc_changed = 0;
      this.field.inv_term_changed = 0;
      this.field.exchange_rate_status = this.org_details.exchange_rate_status;
      this.inv_status = this.field.inv_status;
      this.old_cus_id = this.field.cus_id;
      this.old_currency_code = this.field.currency_code;
      this.old_exchange_rate = this.field.unit_currency_value;
      this.field.type = "invoice";
      this.field.is_adjustment = this.field.is_adjustment
        ? this.field.is_adjustment
        : this.general_settings_details.preferences.is_adjustment;
         this.field.discount_cat =  this.field.discount_cat == 4 || this.field.discount_cat == ''? this.general_settings_details.preferences.discount_cat: this.field.discount_cat; 
      //  update address data
      // billing state and country
      var bill_sal_state = this.list.address_details[0].state
        ? this.list.address_details[0].state
        : "";
      var bill_sal_country = this.list.address_details[0].country
        ? this.list.address_details[0].country
        : "";
      // shipping state and country
      var ship_sal_state = this.list.address_details[1].state
        ? this.list.address_details[1].state
        : "";
      var ship_sal_country = this.list.address_details[1].country
        ? this.list.address_details[1].country
        : "";

      this.field["address"] = {
        bill_sal_addr_type: 1,
        is_billing: this.list.address_details[0].is_billing,
        cus_bill_addr_id: this.list.address_details[0].cus_addr_id,
        cus_ship_addr_id: this.list.address_details[1].cus_addr_id,
        is_shipping: this.list.address_details[1].is_shipping,
        bill_sal_addr_line_1: this.list.address_details[0].addr_line_1,
        bill_sal_addr_line_2: this.list.address_details[0].addr_line_2,
        bill_sal_state: bill_sal_state,
        bill_sal_city: this.list.address_details[0].city,
        bill_sal_pincode: this.list.address_details[0].pincode,
        bill_sal_country: bill_sal_country,
        ship_sal_addr_type: 2,
        ship_sal_addr_line_1: this.list.address_details[1].addr_line_1,
        ship_sal_addr_line_2: this.list.address_details[1].addr_line_2,
        ship_sal_state: ship_sal_state,
        ship_sal_city: this.list.address_details[1].city,
        ship_sal_pincode: this.list.address_details[1].pincode,
        ship_sal_country: ship_sal_country
      };
      //  update address to flyout
      this.cusaddress = JSON.parse(JSON.stringify(this.field["address"]));
      this.customeraddress = this.list.cus_addr;
      this.old_inv_itm_ids = this.list.old_inv_itm_ids;
      //  payment temd dropdown
      this.field.pymnt_terms = this.list.header_details.pymnt_terms;
      this.pymnt_terms = this.list.header_details.pymnt_terms;
      //  item details
      this.items = this.list.item_details;
      if (!this.$route.query.sales_order) {
        this.itemfromsalesorder = false;
      }
      if (this.$route.query.clone_id || this.$route.query.sales_order) {
        this.field.code_id = this.active_code_id.code_id;
        this.field.suffix = this.active_code_id.suffix;
        this.field.prefix = this.active_code_id.prefix;
        this.field.inv_no =
          this.active_code_id.prefix + this.active_code_id.suffix;
        this.selectDate(new Date());
      }
      if (this.$route.query.clone_id) {
        this.field.sal_id = "";
      }
    }
  },
  updated: function() {
    this.$nextTick(function() {
      if (this.update_price == false) {
        //  show changing customer details only on satisfying following condition

        for (var i = 0; i < this.items.length; i++) {
          var pdt_name = "pdt_name_typeahead_" + i;
          this.$refs[pdt_name][0].inputValue = this.items[i].products[i].label;
          //  mask and remover
          $("#vuebootsearcher" + i + " input").addClass("mask");
          $("#vuebootsearcher" + i + " .input-group").append(
            "<span class='la la-close p-2 mt-1 remover cursor_pointer bg-white'></span>"
          );
        }
        this.update_price = true;
      }
    });
  },
  async created() {
    this.field.inv_desc_changed = 0;
    this.field.inv_term_changed = 0;
    await this.updateFields();
    await this.getExchangeRateValue(1);
    await this.recalcUnitPrice(this.field.unit_currency_value);
    //  customer credit limt
    await this.$store
      .dispatch("customer/getCustomerLimit", this.field.cus_id)
      .then(() => {
        this.total_due_amt = this.creditlist.total_due_amt; // get the credit limit
        this.cus_credit_limit = this.creditlist.cus_credit_limit; // get the total due amount
        this.unused_credits = this.creditlist.unused_credits; // get the total due amount
      });
    this.field.exchange_rate_status = this.org_details.exchange_rate_status;
    this.field.seller_gst_no = this.org_details.gst_no;
    this.field.code_id = this.active_code_id.code_id;
    this.field.suffix = this.active_code_id.suffix;
    this.field.prefix = this.active_code_id.prefix;
    this.field.inv_no = this.active_code_id.prefix + this.active_code_id.suffix;
    this.field.seller_gst_type = this.org_details.gst_type;
    this.field.internal_notes = this.inv_settings_details.internal_notes;
    this.field.cus_inv_notes = this.inv_settings_details.cus_inv_notes;
    this.bill_of_supply = this.general_settings_details.preferences.bill_of_supply;
    for (var i = 0; i < this.inv_settings_details.custom_field.length; i++) {
      if (this.inv_settings_details.custom_field[i].status == 1 && this.inv_settings_details.custom_field[i].permissions == 'write') {
        this.$set(
          this.field,
          this.inv_settings_details.custom_field[i].field_name,
          this.inv_settings_details.custom_field[i].default_value
        );
      }
    }
    this.field.is_shipping_charge = this.general_settings_details.preferences.is_shipping_charge;

    this.field.is_adjustment = this.general_settings_details.preferences.is_adjustment;

    this.field.warehouse_id = this.primary_warehouse_details.warehouse_id;
    this.field.tax_type_id =
      this.org_details.gst_type == 3
        ? 2
        : this.general_settings_details.preferences.tax_type_id == 3
        ? 2
        : this.general_settings_details.preferences.tax_type_id;
    this.field.discount_cat = this.general_settings_details.preferences.discount_cat;

    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
    //  to watch any updates in field data
    await this.$watch(
      "field",
      function() {
        this.$emit("FormUpdate");
      },
      {
        deep: true
      }
    );
    //  to watch any updates in item data
    await this.$watch(
      "items",
      function() {
        this.$emit("FormUpdate");
      },
      {
        deep: true
      }
    );
  },
  watch: {
    total: {
      deep: true,
      handler: function(val) {
        this.splitted_tax = val.splitted_tax;
        this.total_header = val.total_with_adjustments; // assigning to display in header variable
        if (this.field.discount_cat == 2 || this.field.discount_cat == 3) {
          this.unit_discount = parseFloat(val.unit_discount);
        }
      }
    },
    cus_id(val) {
      if (val != "" && val.length > 2) {
        var data = {
          search_value: $.trim(val),
          search_column: this.search_column
        };
        this.$store
          .dispatch("general/fetchCustomerAdvanceSearchData", data)
          .then(() => {
            this.customers = this.customer_filter_list;
          });
             this.reportingtag = Object.assign({}, ...this.customer_filter_list); 
      }
    }
  },
  computed: {
    pricelistgenerate() {
      var pricelist = [];
      var nonlist = [];
      this.price_list.map(value => {
        if (
          value.status == 1 &&
          (value.pricing_type == "fixed_percentage" ||
            ((this.org_details.org_currency == value.currency_id ||
              this.field.cus_currency == value.currency_id) &&
              value.pricing_type == "per_item"))
        ) {
          pricelist.push(value);
        } else if (this.update_price == true) {
          nonlist.push(value.value);
        }
      });
      if (nonlist.length > 0) {
        this.removepricelist(nonlist);
      }
      return pricelist;
    },
    total() {
      //  calculate the total tax amount with tax value (and splitted with tax value)
      var tax_total_value = 0;
      var total_without_tax = 0;
      var total_discount_amount = 0;
      var total_value = 0;
      var incl_total_without_tax = 0;
      var incl_total_discount_amount = 0;
      var unit_discount = 0;
      // <!------------------------------------tax calculation variables----------------------------->
      var splitted_tax_percent = [];
      var tax_on_taxable_amount = [];
      var splitted_tax_data = [];
      //  calculation for total tax and total amount with tax value
      this.items.reduce((total, value) => {
        if (value.pdt_id != "" && this.update_price == true) {
          //  get tax params
          var tax_id =
            !isNaN(value.tax_id) && value.tax_id != ""
              ? parseFloat(value.tax_id)
              : 0;
          //  get pdt qty params
          var pdt_qty =
            !isNaN(value.pdt_qty) && value.pdt_qty != ""
              ? parseFloat(value.pdt_qty)
              : 0;

          // get pdt with price qty params
          var formal_pdt_price_with_qty = 0;
          //  get unit price and qty(multiple)
          var actual_pdt_price_with_qty =
            parseFloat(value.unit_price) * parseFloat(pdt_qty);

          if (this.field.tax_type_id == 1) {
            //  get the tax percent
            var tax_percent =
              !isNaN(value.tax_id) && value.tax_id != 0
                ? parseFloat(this.tax_list[value.tax_id]["tax_percent"])
                : 0;
            // find the amount before tax
            formal_pdt_price_with_qty =
              parseFloat(actual_pdt_price_with_qty) -
              (parseFloat(actual_pdt_price_with_qty) /
                (1 + parseFloat(tax_percent) / 100)) *
                (parseFloat(tax_percent) / 100);
          } else {
            formal_pdt_price_with_qty =
              parseFloat(value.unit_price) * parseFloat(pdt_qty);
          }
          formal_pdt_price_with_qty =
            typeof formal_pdt_price_with_qty != undefined &&
            !isNaN(formal_pdt_price_with_qty)
              ? parseFloat(formal_pdt_price_with_qty)
              : 0;
          var discount_amount = 0;
          var incl_discount_amount = 0;
          if (this.field.discount_cat == 1) {
            if (value.is_percent == 0) {
              discount_amount =
                !isNaN(value.discount_amount) && value.discount_amount != ""
                  ? parseFloat(value.discount_amount)
                  : 0;
              incl_discount_amount = discount_amount;
            } else {
              discount_amount =
                !isNaN(value.discount_amount) && value.discount_amount != ""
                  ? (formal_pdt_price_with_qty * value.discount_amount) / 100
                  : 0;
              var dis_incl_discount_amount =
                this.field.tax_type_id == 1
                  ? formal_pdt_price_with_qty
                  : actual_pdt_price_with_qty;
              incl_discount_amount =
                !isNaN(value.discount_amount) && value.discount_amount != ""
                  ? (dis_incl_discount_amount * value.discount_amount) / 100
                  : 0;
            }
          } else if (this.field.discount_cat == 2) {
            discount_amount =
              !isNaN(this.unit_discount) && this.unit_discount != ""
                ? formal_pdt_price_with_qty * this.unit_discount
                : 0;

            incl_discount_amount = 0;
          } else if (this.field.discount_cat == 3) {
            discount_amount = 0;
            incl_discount_amount = 0;
          }
          //  to calcualte total product * unit price

          if (this.field.tax_type_id == 1) {
            var inclusive_amt =
              parseFloat(formal_pdt_price_with_qty) -
              parseFloat(incl_discount_amount);
            incl_total_without_tax +=
              (parseFloat(inclusive_amt) * parseFloat(tax_percent)) / 100 +
              parseFloat(inclusive_amt);
          } else {
            incl_total_without_tax +=
              parseFloat(actual_pdt_price_with_qty) -
              parseFloat(incl_discount_amount);
          }
          // <!-----------------------------------dynamic tax calculation based on tax group------------------------------------------>
          if (!isNaN(tax_id) && tax_id != 0 && this.org_details.gst_type == 1) {
            value.tax_ids = this.tax_list[tax_id].tax_ids;
            var tax_ids = value.tax_ids ? value.tax_ids.split(",") : "";
            value.tax_rates = [];
            if (
              tax_ids != "" &&
              tax_ids != null &&
              typeof tax_ids != "undefined"
            ) {
              for (var i = 0; i < tax_ids.length; i++) {
                var taxable_amount =
                  parseFloat(formal_pdt_price_with_qty) -
                  parseFloat(discount_amount);
                var splitted_tax =
                  (taxable_amount *
                    parseFloat(this.tax_main[tax_ids[i]].tax_percent)) /
                  100;
                value.tax_rates[i] = {
                  id: this.tax_main[tax_ids[i]].tax_id,
                  value: this.tax_main[tax_ids[i]].tax_percent,
                  tax_amount: splitted_tax
                };

                if (
                  splitted_tax != null &&
                  typeof splitted_tax != "undefined" &&
                  !isNaN(splitted_tax)
                ) {
                  splitted_tax_percent[tax_ids[i]] = !isNaN(
                    splitted_tax_percent[tax_ids[i]]
                  )
                    ? parseFloat(splitted_tax_percent[tax_ids[i]]) +
                      splitted_tax
                    : parseFloat(splitted_tax);
                  tax_on_taxable_amount[tax_ids[i]] = !isNaN(
                    tax_on_taxable_amount[tax_ids[i]]
                  )
                    ? parseFloat(tax_on_taxable_amount[tax_ids[i]]) +
                      taxable_amount
                    : parseFloat(taxable_amount);
                }

                //  update splitted tax variable
                var hasMatch = this.getIndexValue(
                  splitted_tax_data,
                  "id",
                  tax_ids[i]
                );
                var tax_details = [
                  {
                    id: tax_ids[i],
                    label:
                      this.tax_main[tax_ids[i]].tax_name +
                      "[ " +
                      parseFloat(this.tax_main[tax_ids[i]].tax_percent) +
                      " %]",
                    value: splitted_tax_percent[tax_ids[i]],
                    taxable: tax_on_taxable_amount[tax_ids[i]]
                  }
                ];
                if (!isNaN(parseInt(hasMatch))) {
                  splitted_tax_data[hasMatch] = tax_details;
                } else {
                  splitted_tax_data.push(tax_details);
                }
              }
            }
          }
          // <!------------------------------------End of tax calculation segment---------------------------->
          // <!---------------------------------- calculation of total without tax , total tax and total amount ---------------------->
          //  total without tax
          var discount_cal =
            this.field.discount_cat == 2
              ? parseFloat(value.discount_amount)
              : parseFloat(discount_amount);
          total_without_tax +=
            typeof value.pdt_id == "undefined" ||
            value.pdt_id == "" ||
            pdt_qty == 0
              ? 0
              : parseFloat(formal_pdt_price_with_qty) -
                parseFloat(discount_cal);
          //  total tax value
          tax_total_value +=
            typeof value.pdt_id == "undefined" ||
            value.pdt_id == "" ||
            pdt_qty == 0
              ? 0
              : parseFloat(value.tax_value);

          //  grand total
          var total_amount =
            parseFloat(formal_pdt_price_with_qty) +
            parseFloat(value.tax_value) -
            parseFloat(discount_amount);
          total_amount =
            typeof value.pdt_id == "undefined" ||
            value.pdt_id == "" ||
            pdt_qty == 0
              ? 0
              : total_amount;
          // <!---------------------------------- end of calulation(total without tax , total tax and total amount) ---------------------->
          return !isNaN(parseFloat(total_amount))
            ? total + parseFloat(total_amount)
            : parseFloat(total);
        }
      }, 0);
      total_value =
        this.field.tax_type_id == 2
          ? parseFloat(total_without_tax)
          : parseFloat(incl_total_without_tax);
      // <!---------------------header discount calculation ------------------------>
      if (this.field.discount_cat == 2 || this.field.discount_cat == 3) {
        if (this.field.is_discount_percent == 0) {
          total_discount_amount =
            !isNaN(this.field.discount_amount) &&
            this.field.discount_amount != ""
              ? parseFloat(this.field.discount_amount)
              : 0;

          incl_total_discount_amount = total_discount_amount;
        } else if (this.field.discount_cat == 2) {
          total_discount_amount =
            !isNaN(this.field.discount_amount) &&
            this.field.discount_amount != ""
              ? (total_without_tax * this.field.discount_amount) / 100
              : 0;
          incl_total_discount_amount =
            !isNaN(this.field.discount_amount) &&
            this.field.discount_amount != ""
              ? (total_value * this.field.discount_amount) / 100
              : 0;
        } else if (this.field.discount_cat == 3) {
          var incl_discountable_amount =
            this.field.tax_type_id == 2
              ? parseFloat(total_without_tax) + parseFloat(tax_total_value)
              : parseFloat(incl_total_without_tax);

          total_discount_amount =
            !isNaN(this.field.discount_amount) &&
            this.field.discount_amount != ""
              ? (incl_discountable_amount * this.field.discount_amount) / 100
              : 0;
          incl_total_discount_amount =
            !isNaN(this.field.discount_amount) &&
            this.field.discount_amount != ""
              ? (incl_discountable_amount * this.field.discount_amount) / 100
              : 0;
        }

        // <!--------------------------- find unit discount for each line item------------>
        unit_discount =
          parseFloat(total_discount_amount) / parseFloat(total_without_tax);

        total_value -= parseFloat(incl_total_discount_amount);
      }

      if (this.field.tax_type_id == 2) {
        //  add tax amount after discount
        total_value += parseFloat(tax_total_value);
      }
      // Shpping Amount
      var shipping_amount =
        this.field.is_shipping_charge && this.field.shipping_amount > 0
          ? parseFloat(this.field.shipping_amount)
          : 0;
      // <!---------------------end of header discount calculation ------------------------>
      // <!------------------------ ajdustments if any--------------------->
      var adjustments =
        !isNaN(this.field.adjustments) &&
        this.field.is_adjustment &&
        this.field.adjustments != "" &&
        this.field.adjustments != null
          ? parseFloat(this.field.adjustments)
          : 0;
      var total_with_adjustments =
        parseFloat(total_value) + adjustments + shipping_amount;
      total_with_adjustments =
        total_with_adjustments == ""
          ? Math.abs(total_with_adjustments.toFixed(2))
          : total_with_adjustments.toFixed(2);

      // <!----------------- end of appending splitted tax calculation to the div------->

      // <!--------------returning all the calculated amount -------------------------->
      return {
        unit_discount: unit_discount,
        splitted_tax: splitted_tax_data,
        total_discount_amount:
          typeof total_discount_amount != undefined &&
          !isNaN(total_discount_amount)
            ? parseFloat(total_discount_amount).toFixed(2)
            : 0,
        total_without_tax:
          typeof total_without_tax != undefined && !isNaN(total_without_tax)
            ? parseFloat(total_without_tax).toFixed(2)
            : 0,
        incl_total_without_tax:
          typeof incl_total_without_tax != undefined &&
          !isNaN(incl_total_without_tax)
            ? parseFloat(incl_total_without_tax).toFixed(2)
            : 0,
        tax_total_value:
          typeof tax_total_value != undefined && !isNaN(tax_total_value)
            ? parseFloat(tax_total_value).toFixed(2)
            : 0,
        total_with_adjustments:
          typeof total_with_adjustments != undefined &&
          !isNaN(total_with_adjustments)
            ? parseFloat(total_with_adjustments).toFixed(2)
            : 0
      };
    },
    // mix this into the outer object with the object spread operator
    ...mapState({
      enablepricelist: state => state.permission.price_list,
      price_list: state => state.sales.price_list,
      customer_filter_list: state => state.general.customer_filter_list,
      product_filter_list: state => state.general.product_filter_list,
      state_list: state => state.sales.state_list,
      product_list: state => state.sales.product_list,
      export_type_list: state => state.sales.export_type_list,
      active_code_id: state => state.sales.active_code_id,
      location_detail: state => state.sales.location_detail,
      tax_list: state => state.sales.tax_list,
      tax_main: state => state.sales.tax_main,
      tag_list: state => state.sales.tag_list,
      sales_person_list: state => state.sales.sales_person_list,
      pjt_list: state => state.sales.pjt_list,
      code: state => state.sales.code,
      pymnt_trm_list: state => state.sales.pymnt_trm_list,
      updated_id: state => state.invoice.updated_id,
      list: state => state.invoice.list,
      message: state => state.invoice.message,
      address: state => state.customer.address,
      updatedtag_id: state => state.sales.updatedtag_id,
      exempt_reason_list: state => state.sales.exempt_reason_list,
      customer_addr: state => state.customer.customer_addr,
      exchange_rate_message: state => state.currency.message,
      exchange_rate_type: state => state.currency.type,
      credit_success: state => state.customer.message,
      creditlist: state => state.customer.creditlist,
      update_exempt_id: state => state.products.updatedtag_id
    }),
    currency_details: {
      get() {
        return this.$store.state.customer.currency_details;
      },
      set(val) {
        this.$store.state.customer.currency_details = val;
      }
    },
    ...mapGetters([
      "primary_warehouse_details",
      "org_details",
      "inv_settings_details",
      "general_settings_details",
      "reporting_tags",
      "stock_settings",
      "orgCurrency",
      "cus_settings_details"
    ])
  }
};
</script>
<style>
.required:after {
  color: #e32;
  content: " *";
  display: inline;
}
</style>
<style scoped>
.create-cus {
  margin-right: 20px !important;
  height: 32px;
  margin-top: 0px !important;
}

.customer_search {
  width: 629px;
}
@media (min-width: 10px) and (max-width: 1169px) {
  .customer_search {
    width: 350px;
  }
}
input.form-control.bord-bottom-input {
  border: unset !important;
  border-bottom: 1px dashed #e0e0e0 !important;
  width: 100px !important;
  padding: 7px;
}
select.form-control.bord-bottom-input {
  border: unset !important;
  padding: 7px;
  border-bottom: 1px solid #e0e0e0 !important;
}
.custom-select-sm {
  font-size: 90%;
}
</style>